export default {
  id: "PENGENAL",
  dashboard: "Dasbor",
  warning: "Peringatan",
  users: "Pengguna ",
  farms: "Farms ",
  animals: "Hewan ",
  action: "Tindakan",
  actionList: "Daftar aksi",
  drugInventory: "Inventarisasi Obat ",
  inseminatorStatistics: "Statistik inseminator ",
  organizationNTR: "Organisasi NTR ",
  genotypePerformance: "Kinerja genotipe ",
  semenAutomation: "Otomatisasi Semen ",
  activityLogs: "Log aktivitas",
  username: "Nama belakang",
  title: "Judul",
  deactivated: "Dinonaktifkan ",
  name: "Nama",
  email: "Surel",
  emailAddress: "Alamat email",
  mobileNum: "Nomor handphone",
  emailOrMobile:"Email/Ponsel",
  role: "Peran",
  roles: "Peran",
  department: "Departemen",
  status: "Status",
  pages: "Halaman ",
  departments: "Departemen ",
  password: "Kata sandi",
  cancel: "Membatalkan",
  submit: "Kirim",
  error: "kesalahan",
  success: "kesuksesan",
  Browse: "Jelajahi",
  orDropYourFileCsvXlsXlsxHere:
    "Atau letakkan file Anda (CSV, XLS, XLSX) di sini",
  search: "Mencari",
  apply: "Menerapkan",
  select: "Pilih",
  previous: "Sebelumnya",
  mandatory: "Wajib",
  dropYourFileHere:
    "Atau letakkan file Anda (CSV, XLS, XLSX, PDF, DOCX, PNG, JPEG) di sini",
  restoreDefault: "Kembali ke awal",
  pending: "Tertunda",
  completed: "Lengkap",
  remove: "Menghapus",
  update: "Memperbarui",
  removeFile: "Hapus file",
  uploadFile: "Unggah data",
  pleaseChoosePreferedLanguage: "Pilih bahasa pilihan Anda",
  edit: "Edit",
  activate: "Mengaktifkan",
  deactivate: "Menonaktifkan",
  recievedOrders: "Menerima perintah",
  chartRepresentation: "Representasi bagan",
  nameIsRequired: "Nama diperlukan",
  export: "Ekspor",
  noFilesAvailable: "Tidak ada file yang tersedia",
  selectDepartmentToshowRoles: "Pilih departemen untuk menunjukkan peran",
  selectDepartmentWithActiveRoles: "Pilih departemen dengan peran aktif",
  nameCanContainOnlyAlphabets: "Nama hanya bisa berisi absen ",
  nameMustBeLessThan15Chars: "Nama harus kurang dari 30 karakter ",
  emailRequired: "Email diperlukan",
  invalidEmailFormat: "Format email salah",
  mobNumReq: "Nomor ponsel diperlukan",
  invalidMobFormat: "Format nomor ponsel tidak valid.",
  passwordRequired: "Katakunci dibutuhkan",
  departmentReq: "Departemen diperlukan",
  roleReq: "Diperlukan peran",
  unableToUpdate: "Tidak dapat memperbarui",
  orignalName: "Nama asli",
  uploadedDate: "Tanggal Diunggah",
  fileName: "Nama file",
  importNum: "Nomor impor",
  languagePreferences: "Pilihan Bahasa",
  pleaseTryAgainAfterSometime: "Silakan coba setelah beberapa saat",
  noChanges: "Tidak ada perubahan",
  nothingchanged: "Tidak ada yang berubah",
  pleaseChooseAnImageFile: "Pilih file gambar",
  fileIsTooBigSelectUnder1MB:
    "File Anda terlalu besar! Pilih gambar di bawah 1MB",
  phoneShouldHave10Chars: "Telepon harus memiliki 10 karakter",
  onlyCSVAllowed: "Hanya file CSV yang diizinkan",
  loadingPleaseWait: "Memuat ... tolong tunggu",
  manager: "Pengelola",
  administrator: "administrator",
  Comingsoon: "Segera hadir",
  totalAnimals: "Total hewan",
  receivedOrders: "Menerima pesanan",
  drugs: "Narkoba",
  detailedAnalysis: "Analisis terperinci",
  barGraphRepOfActiveUsersAndDeactivateUsers:
    "Representasi grafik batang dari pengguna aktif dan pengguna deaktif",
  barGraphRepOfRegAnimalsVsFarm:
    "Representasi grafik batang dari hewan terdaftar vs farm",
  roleNumber: "Nomor peran",
  roleName: "Nama peran",
  active: "Aktif",
  inactive: "Tidak aktif",
  admin: "Admin",
  addRole: "Tambahkan peran",
  addRoles: "Tambahkan peran",
  permissions: "Izin ",
  sr: "Sr.",
  moduleName: "Nama modul",
  view: "Melihat",
  deptNo: "Dept No.",
  selectByCategory: "Pilih berdasarkan kategori",
  weeklyAnalytics: "Analisis mingguan",
  pregnancy: "Kehamilan",
  analytics: "Analitik",
  calendar: "Kalender",
  productName: "Nama Produk",
  volumeSold: "Volume dijual",
  recordPoints: "Poin rekaman",
  inStock: "Persediaan",
  revenue: "Pendapatan",
  stockStatus: "Status stok",
  barChart: "Grafik batang",
  lineChart: "Bagan baris",
  indexReturns: "Indeks pengembalian",
  chart: "Bagan",
  time: "waktu",
  production: "Produksi",
  customization: "Penyesuaian",
  recordsPerPage: "Catatan per halaman",
  noDataAvailable: "Tidak ada data yang tersedia",
  reporting: "Pelaporan",
  optional: "Opsional",
  note: "Catatan",
  notes: "Catatan ",
  date: "Tanggal",
  kG: "Kg ",
  weight: "berat",
  type: "Jenis",
  lessthan3Month: "<3 bulan",
  lessthan6Month: "<6 bulan",
  lessthan7Month: "<7 bulan",
  lastWeek: "Minggu lalu",
  thisWeek: "Minggu ini",
  lessthanOneYear: "<1 tahun",
  lessthanTwoYear: "<2 tahun",
  lessthanThreeYear: "<3 tahun",
  lessthanFourYear: "<4 tahun",
  yes: "Ya",
  no: "TIDAK",
  of: "dari",
  notSpecified: "Tidak ditentukan",
  days: "Hari ",
  day: "hari",
  aDay: "satu hari",
  years: "bertahun-tahun",
  year: "tahun",
  unit: "satuan",
  units: "Unit ",
  to: "ke",
  profile: "Profil",
  logOut: "Keluar",
  otherSettings:"Pengaturan lainnya",
  Unit: "Satuan",
  somethingWentWrong: "ada yang salah.",
  toDo: "Melakukan",
  loadingData: "Memuat data ... ",
  taskNumber: "Nomor tugas ",
  taskName: "Nama tugas",
  startDate: "Mulai tanggal",
  dueDate: "Tenggat waktu",
  reason: "Alasan",
  quantity: "Kuantitas",
  cost: "Biaya",
  noRecordFound: "Tidak ada catatan yang ditemukan ",
  dailyUpdates: "Pembaruan harian",
  weeklyUpdates: "Pembaruan mingguan",
  moduleAccessed: "Modul diakses",
  typesOfAccess: "Jenis akses",
  userId: "Identitas pengguna",
  lastLogin: "Login terakhir",
  terminalID: "ID terminal",
  geographicalAccessPoint: "Titik akses geografis",
  iPAddress: "Alamat IP",
  fileAccessed: "File diakses",
  functionAccessed: "Fungsi diakses ",
  webPageURL: "URL halaman web",
  accessType: "Jenis akses",
  unsuccessfulLoginAttempts: "Upaya login yang tidak berhasil ",
  customerAddress: "Alamat pelanggan",
  orderdate: "Tanggal pemesanan",
  postageDate: "Tanggal ongkos kirim",
  postID: "ID pos",
  packingTechnician: "Teknisi pengemasan",
  packingTechnicia: "Teknisi Pengemasan",
  packEdit: "Pengeditan Paket",
  batchNumber: "Nomor batch",
  collectionTechnician: "Teknisi pengumpulan",
  collectionTechnicia: "Technicia pengumpulan",
  preparationTechnicia: "Technicia Persiapan",
  preparationTechnician: "Teknisi Persiapan",
  approvedManually: "Disetujui secara manual",
  researcher: "Peneliti",
  dateOfApproval: "Tanggal persetujuan",
  approvalEdit: "Persetujuan Mengedit",
  searchByAllExceptDate: "Cari oleh semua kecuali tanggal",
  approval: "Persetujuan",
  collection: "Koleksi",
  postage: "Ongkos kirim",
  pack: "Mengemas",
  straws: "Sedotan",
  createdAt: "Dibuat di",
  sireID: "Tuan ID",
  economicIndexValue: "Nilai indeks ekonomi",
  latestCollectionDate: "Tanggal koleksi terbaru",
  locationId: "ID lokasi",
  lastUpdated: "Terakhir diperbarui ",
  print: "Mencetak",
  save: "Menyimpan",
  tax: "Pajak",
  phoneNo: "No Telepon",
  exportAsPDF: "Ekspor sebagai pdf ",
  statusUpdated: "Status diperbarui",
  statusNotUpdated: "Status tidak diperbarui",
  inProgress: "Sedang berlangsung",
  assignedTo: "Ditugaskan untuk",
  taskId: "ID tugas",
  createdDate: "Tanggal dibuat",
  numberOfAnimals: "Jumlah hewan",
  healthRecordSubmittedSuccess: "Catatan kesehatan berhasil diserahkan",
  healthRecordSubmitted: "Catatan Kesehatan Diserahkan.",
  InseminationRecordSubmittedSuccesful:
    "Catatan Inseminasi berhasil diserahkan",
  inseminationRecordSubmitted: "Catatan Inseminasi Diserahkan.",
  actionListDailyTask: "Daftar Tindakan - Tugas Harian",
  sinceLastYear: "Sejak tahun lalu",
  sinceLastQuarter: "Sejak kuartal terakhir",
  sinceLastMonth: "Sejak bulan lalu",
  sinceLastWeek: "Sejak minggu lalu",
  drugWithdrawPeriod: "Periode DrugwithDraw",
  diagnosisName: "Nama diagnosis",
  animalWithNoGenetype:
    "Hewan ini tidak memiliki data genotipe apa pun yang terdaftar. Klik tombol di bawah ini untuk mendaftar.",
  nameOfPreviousOwner: "Nama pemilik sebelumnya",
  avatarSize: "Ukuran avatar harus kurang dari 1 mb!",
  testDestination: "Tujuan Tes",
  animalNotAdded: "Hewan tidak ditambahkan",
  registerationSuccessful: "Registrasi berhasil",
  backToAnimalList: "Kembali ke Daftar Hewan",
  addAnotherAnimal: "Tambahkan hewan lain",
  animalDetailsUpdated: "Detail hewan berhasil diperbarui",
  animalUpdatedSuccessfully: "Hewan diperbarui dengan sukses",
  animalNotUpdated: "Hewan tidak diperbarui",
  notMember: "Bukan seorang anggota?",
  requestAccess: "Meminta akses",
  typePassword: "Harap ketik kata sandi.",
  minChars: "minimum 6 karakter",
  typeConfirmPassword: "Ketik Konfirmasi Kata Sandi",
  passConfig: "Konfirmasi kata sandi tidak cocok.",
  invalidEmailMobile: "Email/format seluler yang tidak valid",
  passwordNotEmpty: "Kata sandi tidak bisa kosong",
  passwordLength: "Kata sandi lenght tidak bisa kurang dari 8 karakter",
  cityVillage: "Kota / desa",
  districtRegion: "Distrik / wilayah",
  alreadyHaveAnAccount: "Alreday punya akun?",
  genetypeUpdated: "Genotipe diperbarui",
  genetypeNotUpdated: "Genotipe tidak diperbarui",
  sellTrade: "Jual/perdagangan",
  milkingDevon: "Meman susu devon breeding stock untuk dijual",
  detailedDescription: "Detil Deskripsi",
  longPara:
    "American memerah susu Devon Bulls sapi jantan dan sapi. Semuanya terdaftar murni. Hewan -hewan kita disosialisasikan dengan baik, dan hanya dibesarkan di atas rumput, jerami dan banyak cinta. Hewan -hewan cantik ini adalah jenis tripple yang langka untuk susu, oroksen daging. Saham A-1-A2 & A-2A-A2 tersedia. Silakan hubungi atau email untuk informasi lebih lanjut atau untuk mengatur vist kawanan.",
  contactSeller: "Hubungi penjual",
  enterListingTitle: "Masukkan judul daftar",
  livestocktype: "Jenis ternak",
  uploadImage: "Unggah gambar",
  mobilePhone: "Nomor ponsel",
  myLivestock: "Ternak saya",
  livestockObservations: "Pengamatan ternak",
  selectFromRegisteredAnimals: "Pilih dari daftar hewan terdaftar",
  selectOption: "Pilih opsi",
  selectTypeObservation: "Pilih jenis pengamatan",
  attachVeteinaryDocument: "Lampirkan Dokumen Hewan",
  addsensorReading: "Tambahkan pembacaan sensor",
  myDocument: "Dokumen-dokumen saya",
  enterAKeyword: "Masukkan kata kunci",
  documentType: "Tipe dokumen",
  registerEditLivestock: "Daftar/Edit Ternak",
  editLivestockProfile: "Edit Profil Ternak",
  copy: "Menyalin",
  dateOfRegister: "Tanggal Daftar",
  livestockType: "Jenis ternak",
  registerNewLivestock: "Daftarkan ternak baru",
  enterUniqueTag: "Masukkan tag unik #",
  color: "Warna",
  gender: "Jenis kelamin",
  male: "Pria",
  female: "Perempuan",
  damm: "Bendungan #",
  siree: "Sire #",
  dateOfSaleAuction: "Tanggal Penjualan/Lelang Penjualan",
  auctionRecord: "Catatan Lelang Daftar Maut",
  distinguishingFeatures: "Fitur yang membedakan",
  keywordListing: "Kata kunci atau ID daftar",
  adType: "Jenis iklan",
  activeListingFund: "1 Daftar aktif ditemukan",
  setupSensors: "Mengatur sensor",
  serialNumber: "Nomor seri",
  sensorLocation: "Lokasi sensor",
  sensorType: "Jenis sensor",
  installationDate: "Tanggal instalasi",
  ExpirationDate: "Tanggal habis tempo",
  addGeo: "Tambahkan geolokasi",
  addMoreSensors: "Tambahkan lebih banyak sensor",
  trackAndTrace: "Melacak dan melacak",
  createNewShipment: "Buat kiriman baru",
  workflowReference: "Referensi alur kerja",
  invoiceDate: "Tanggal faktur",
  trackShipment: "Lacak pengiriman",
  totalShipments: "Total pengiriman",
  activeShipment: "Pengiriman Aktif",
  completedObjectives: "Tujuan Selesai",
  processedPayments: "Pembayaran yang diproses",
  pointOfDestination: "Titik tujuan",
  sellerInformation: "Informasi penjual",
  selectSellerConsignor: "Pilih penjual/pengirim",
  pointOfOrigin: "Titik asal",
  buyerInfo: "Informasi pembeli",
  selectBuyerConsignor: "Pilih Pembeli/Pengirim",
  addSensorTriggers: "Tambahkan pemicu sensor",
  processPayments: "Proses pembayaran",
  defineShippingContract: "Tentukan kontrak pengiriman",
  addDigitize: "Tambahkan & Digitalkan Dokumen",
  currentlyOnFarm: "Saat ini di pertanian",
  addSire: "Tambahkan Sire",
  addApproval: "Tambahkan persetujuan",
  addCollection: "Tambahkan koleksi",
  addStraws: "Tambahkan sedotan",
  addPack: "Tambahkan paket",
  addPostage: "Tambahkan ongkos kirim ",
  searchBySire: "Cari dengan Sire",
  anyDataChangeMightBeLost: "Perubahan data apa pun mungkin hilang",
  wouldYouLikeToSaveOrWantToLeaveWithoutSaving:
    "Apakah Anda ingin menabung atau ingin pergi tanpa menabung",
  leave: "Meninggalkan",
  stay: "Tinggal",
  animalFarm: "Peternakan",
  animalFarmH: "Peternakan",
  animalOrigin: "Asal Hewan",
  animalOriginH: "Asal Hewan",
  farmOfOrigin: "Peternakan Asal",
  farmOfOriginH: "Peternakan Asal",
  selectFarm: "Pilih Peternakan",
  searchFarm: "Ladang Pencarian",
  confirmation: "Konfirmasi",
  proceed: "melanjutkan",
  ok: "OKE",
  animal: {
    tagH: "Menandai",
    tagNumberH:
      "Nomor tag:nda dapat menambahkan warna serta nomor. Itu tidak terbatas hanya pada angka.",
    goveRegNoH:
      "Rincian identifikasi yang dapat mencakup nama dan alamat individu, agen individu untuk layanan proses, lokasi kegiatan yang akan dilakukan, dan deskripsi layanan yang disediakan individu.",
    birthWeightH: "Berat lahir betis",
    birthEaseH:
      "Kelahiran di ternak adalah proses alami tetapi kadang -kadang mungkin ada masalah kelahiran di mana bendungan membutuhkan bantuan dari petani/penggembala.",
    birthFarmH: "Pertanian kelahiran",
    surrogateDamH: "Id bendungan embrio siapa yang digunakan",
    ownerH: "Ini adalah nama pemilik hewan.",
    damH: "ID bendungan binatang.",
    sireH: "ID dari Sire Animal.",
    breedH: "Ini adalah jenis hewan.",
    conceptionMethodH: "Bagaimana hewan itu dikandung.",
    genderH: "Jenis kelamin hewan.",
    dobH: "Tanggal lahir hewan.",
    operatorH: "Nama orang yang mengisi informasi hewan ini.",
    removalFarmH: "Hewan yang dihilangkan di peternakan",
    dateOfRemovalH: "Tanggal pemindahan hewan",
    destinationOfRemoval: "Tempat tujuan hewan yang dihilangkan",
    reasonOfRemovalH: "Alasan pemindahan hewan",
    trackingNumberH: "Nomor yang ditugaskan untuk hewan saat hewan dihapus",
    brandH: "Merek-merek sebuah tanda permanen yang dibakar ke sapi itu.",
    tattoH: "Tato hewan.",
    hornStatusH: "Apakah hewan itu dehorned.",
    animalOriginH: "Negara asal hewan.",
    previousOwnerH:
      "Nama pemilik hewan sebelumnya jika itu adalah yang matang.",
    twinH:
      "Lapangan ini mengatakan apakah hewan itu memiliki kembar atau tidak.",
    regBreedAssoNoH: "Pendaftaran dengan asosiasi/masyarakat breed.",
    breedAssoNameH: "Nama asosiasi/masyarakat di mana hewan itu terdaftar",
    breederH: "Ini adalah nama organisasi yang memasok hewan itu.",
    noteH: "Catatan penting tentang hewan itu.",
    accuracyWeight_for_field: "Berat akurasi ",
    conception: "Pembuahan",
    addAnAnimal: "Tambahkan binatang",
    addAnimal: "Tambahkan binatang",
    registerAnAnimal: "Daftarkan hewan",
    uploadAnAnimal: "Unggah hewan",
    animalRegistration: "Pendaftaran hewan",
    animalDetails: "Detail hewan",
    tag: "Menandai",
    tagNumber: "Nomor tag",
    govtRegNumber: "Pemerintah. Nomor pendaftaran",
    birthWeight: "Berat lahir",
    birthEase: "Kelahiran Kelahiran",
    birthFarm: "Pertanian kelahiran",
    surrogateDam: "Bendungan pengganti",
    owner: "Pemilik",
    ownershipType: "Jenis kepemilikan",
    animalDiseaseRecord: "Animaldiseaserecord",
    govtReg: "Pemerintah. Reg",
    regDate: "Tanggal reg",
    dam: "Bendungan",
    sire: "Bapak",
    heifer: "Heifer",
    steer: "Steer",
    calf: "Anak sapi",
    farmHerd: "Pertanian/kawanan",
    femaleCalf: "Betis betina",
    maleCalf: "Anak sapi jantan",
    newCalves: "Anak sapi baru",
    breed: "Keturunan",
    conceptionMethod: "Metode konsepsi",
    gender: "Jenis kelamin",
    dateOfBirth: "Tanggal lahir",
    operator: "Operator",
    animalRemovedFarm: "Hewan yang dihilangkan peternakan ",
    dateOfAnimalRemoval: "Tanggal pemindahan hewan ",
    destinationOfRemovedAnimal: "Tujuan hewan yang dihilangkan ",
    reasonOfRemoval: "Alasan penghapusan ",
    optionalAnimalInformation: "Informasi Hewan Opsional ",
    animalPicture: "Gambar binatang ",
    trackingNumber: "Melacak nomor",
    brand: "Merek",
    tatto: "Tato ",
    hornStatus: "Status tanduk ",
    animalOrigin: "Asal Hewan ",
    previosOwner: "Pemilik previos ",
    twin: "Kembar",
    InABreedAssociation: "Reg. # dalam asosiasi breed ",
    nameOfBreedAssociations: "Nama asosiasi breed ",
    breedAssociations: "Asosiasi Breed",
    breederSupplier: "Peternak (pemasok) ",
    importAnimal: "Impor hewan ",
    loadingAnimals: "Memuat hewan ... tolong tunggu",
    totalRegAnimals: "Total Reg. Hewan",
    totalPregnantAnimals: "Total hewan hamil",
    pregnantAnimalHistory: "Riwayat hewan hamil ",
    dailyAnimalPregnancyUpdates: "Pembaruan kehamilan hewan setiap hari ",
    animalHistory: "Sejarah Hewan",
    dailyAnimalUpdates: "Pembaruan Hewan Harian",
    totalPregnant: "Total hamil",
    totalNewBorn: "Total New Born",
    searchByIDGOVRegTag: "Cari dengan ID, Gov Reg dan Tag",
    noANIMALAVAILABLE: "Tidak ada hewan yang tersedia",
    associationNumber: "Nomor asosiasi",
    destinationName: "Nama tujuan",
    plastic: "Plastik",
    metal: "Logam",
    naturalMating: "Perkawinan alami ",
    artificialInsemination: "Inseminasi buatan",
    embryoTransfer: "Transfer embrio ",
    noAssistance: "Tidak ada bantuan ",
    someAssistance: "Beberapa bantuan ",
    mechanicalAssistance: "Bantuan mekanis ",
    aCesareanSection: "Bagian sesar ",
    abnormalDelivery: "Pengiriman abnormal ",
    male: "Pria",
    female: "Perempuan",
    sale: "Penjualan",
    slaughter: "Pembantaian",
    death: "Kematian",
    theft: "Pencurian",
    other: "Lainnya",
    horned: "Bertanduk",
    polled: "Dipoleskan ",
    dehorned: "Dehorned ",
    details: "Detail ",
    performance: "Pertunjukan",
    geneticWorth: "Nilai genetik ",
    healthRecord: "Catatan Kesehatan ",
    genotypeData: "Data genotipe ",
    reminders: "Pengingat",
    activityLog: "Log aktivitas",
    activityLogDetails: "Rincian log aktivitas ",
    editAnimal: "Edit Hewan ",
    familyInfo: "Info keluarga ",
    breedInfo: "Info breed ",
    identification: "Identifikasi",
    removalInfo: "Info penghapusan ",
    iDOfAnimalDam: "ID bendungan binatang.",
    iDOfAnimalSire: "ID dari Sire Animal.",
    iDOfDamEmbryoUsed: "ID bendungan embrio siapa yang digunakan. ",
    animalHasATwinOrNot: "Apakah hewan itu memiliki kembar atau tidak. ",
    breedType: "Tipe breed ",
    breedOfTheAnimal: "Ini adalah jenis hewan. ",
    regBreedAssociations: "Pendaftaran dengan asosiasi/ masyarakat breed. ",
    nameOfAssociationsSocieties:
      "Nama asosiasi/masyarakat di mana hewan itu terdaftar. ",
    nameOfTheOrgSuppliedAnimal:
      "Ini adalah nama organisasi yang memasok hewan itu. ",
    countryOriginAnimal: "Negara asal hewan. ",
    birthFarmID: "ID pertanian lahir ",
    farmIDAnimalBorn: "ID peternakan tempat hewan itu lahir. ",
    currentOwner: "Pemilik saat ini ",
    nameOfOwnerAnimal: "Ini adalah nama pemilik hewan. ",
    registrationDate: "Tanggal registrasi",
    previousOwner: "Pemilik sebelumnya",
    nameOfOperator: "Nama operator ",
    dateAnimalRemoved: "Tanggal saat hewan dilepas. ",
    destinationPlaceRemovedAnimal:
      "Tempat tujuan untuk hewan yang dihilangkan ",
    namePersonFillAnimalInformation:
      "Nama orang yang mengisi informasi hewan ini.",
    reasonOfAnimalRemoval: "Alasan pemindahan hewan ",
    reasonWhyTheAnimalIsRemoved: "Alasan mengapa hewan itu dihapus ",
    processingDate: "Tanggal pemrosesan ",
    DateInformationFilledChanged:
      "Tanggal ketika informasi saat ini diisi atau diubah. ",
    animalID: "ID Hewan ",
    UniqueIdAnimal: "Ini adalah id unik dari hewan itu. ",
    plasticTagNumber: "Nomor tag plastik ",
    numberAnimalTag: "Jumlah tag hewan. ",
    rFTagNumber: "Nomor tag RF ",
    numberAnimalRFTag: "Jumlah tag RF hewan. ",
    govtRegNumb: "Pemerintah. Nomor reg ",
    govtRegistrationNumber:
      "Rincian identifikasi yang dapat mencakup nama dan alamat individu, agen individu untuk layanan proses, lokasi kegiatan yang akan dilakukan, dan deskripsi layanan yang disediakan individu. ",
    numberAssignedAnimalIsRemoved:
      "Nomor pelacakan adalah salah satu ID hewan yang digunakan untuk melacak aktivitas hewan. ",
    dateOfAnimalRegistration: "Tanggal pendaftaran hewan ",
    stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal:
      "Merek-merek sebuah tanda permanen yang dibakar ke sapi itu. ",
    tattoOnAnimal: "Tato pada hewan. ",
    whetherTheAnimalIsDehorned: "Apakah hewan itu dehorned. ",
    milkingAnimals: "Hewan memerah susu",
    studAnimals: "Hewan pejantan",
    animalInseminationRecord: "Catatan Inseminasi Hewan",
    numOfStrawsOrdered: "Jumlah sedotan dipesan",
    totalNumOfStraws: "Jumlah total sedotan",
    strawId: "ID jerami",
    addSireAutomation: "Tambahkan otomatisasi sire",
    addApprovalAutomation: "Tambahkan otomatisasi persetujuan",
    addCollectionAutomation: "Tambahkan otomatisasi koleksi",
    addStrawsAutomation: "Tambahkan otomatisasi sedotan",
    addPackAutomation: "Tambahkan otomatisasi paket",
    addPostageAutomation: "Tambahkan otomatisasi ongkos kirim ",
    searchBySire: "SearchBysire",
    numberOfProgenies: "Jumlah progeni",
    sireEdit: "Sire Edit ",
    searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId:
      "ari dengan ID jerami, jumlah total sedotan, nomor batch dan ID lokasi",
    searchByPackIdNumberOfStrawsOrderedPackingTechnicia:
      "Cari dengan ID paket, jumlah sedotan yang dipesan, technicia pengepakan",
    searchByCollectionAndPreparationTechnicia:
      "Cari dengan pengumpulan dan persiapan Technicia",
    registerSemenAutomation: "Daftarkan Otomatisasi Semen",
    addSemenAutomation: "Tambahkan otomatisasi semen",
    strawAutomationRegistered: "Otomasi Jerami Terdaftar",
    strawAutomationRegisteredNotRegistered:
      "Otomatisasi jerami terdaftar tidak terdaftar",
    sireAutomationRegistered: "Sire Automation terdaftar",
    sireAutomationNotRegistered: "Otomatisasi sire tidak terdaftar",
    postageAutomationIsRegistered: "Otomatisasi ongkos kirim terdaftar",
    postageAutomationNotRegistered: "Otomatisasi ongkos kirim tidak terdaftar",
    packAutomationIsRegistered: "Otomatisasi paket terdaftar",
    packAutomationNotRegistered: "Paket otomatisasi tidak terdaftar",
    postageAutomationIsUpdated: "Otomatisasi ongkos kirim diperbarui",
    postageAutomationNotUpdated: "Otomatisasi ongkos kirim tidak diperbarui",
    packAutomationIsUpadted: "Otomatisasi paket ditingkatkan",
    packAutomationNotUpadted: "Paket otomatisasi tidak ditingkatkan",
    collectionAutomationUpdated: "Otomatisasi Koleksi Diperbarui",
    collectionAutomationNotUpdated: "Otomatisasi koleksi tidak diperbarui",
    approvalAutomationIsUpdated: "Otomatisasi persetujuan diperbarui",
    approvalAutomationIsNotUpdated: "Otomatisasi persetujuan tidak diperbarui",
    collectionAutomationRegistered: "Otomasi Koleksi Terdaftar",
    collectionAutomationNotRegistered: "Otomatisasi koleksi tidak terdaftar",
    approvalAutomationIsRegistered: "Otomatisasi persetujuan terdaftar",
    approvalAutomationIsNotRegistered:
      "Otomatisasi persetujuan tidak terdaftar",
    strawAutomationUpdated: "Otomatisasi jerami diperbarui",
    strawAutomationIsNotUpdated: "Otomatisasi jerami tidak diperbarui",
    searchSire: "Cari Sire",
    performanceInfo: {
      milk: "Susu",
      liveweight: "LiveWeight ",
      score: "Skor",
      fertility: "Kesuburan",
      measurements: "Pengukuran ",
      dailyProteinYield: "Hasil protein harian ",
      amountProteinMilkCowDay:
        "Jumlah protein dalam susu yang diperoleh dari sapi pada hari tertentu. ",
      dailyMilkYield: "Hasil susu harian ",
      volumeMilkCowDay:
        "Volume susu yang diperoleh dari sapi tertentu di hari tertentu. ",
      dailyFatYield: "Hasil lemak harian ",
      amountFatMilkCowDay:
        "Jumlah lemak dalam susu yang diperoleh dari sapi pada hari tertentu. ",
      dailyProteinContent: "Kandungan protein harian ",
      dailyFatContent: "Konten lemak harian ",
      milkLactose: "Laktosa susu ",
      amountLactoseMilk: "Jumlah laktosa dalam susu. ",
      milkUrea: "Urea susu ",
      indicatorAmountCrudeProtein:
        "Indikator jumlah protein mentah dalam diet sapi",
      lactationNumber: "Nomor laktasi ",
      ordinalNumLactation: "Jumlah ordinal laktasi. ",
      lengthOfLactation: "Panjang laktasi ",
      lactationLength: "Panjang laktasi (mis. 23 hari) ",
      milkingFrequency: "Frekuensi pemerahan ",
      frequcnyOfMilking: "Frekuensi pemerahan (mis. 2 kali/ hari) ",
      currentWeight: "Berat saat ini",
      weightAnimal: "Berat hewan. ",
      postWeaningGain: "Keuntungan pasca penyapihan ",
      dailyGainInAnimalWeightWeaning:
        "Kenaikan harian dalam berat hewan setelah disapih.",
      weaningWeight: "Menyapih berat ",
      weightAnimalMeasuredWeaning: "Berat hewan diukur dalam sehari menyapih. ",
      averageDailyGain: "Rata -rata keuntungan harian ",
      averageAmountWeightAnimalGainFeedingPeriod:
        "Jumlah rata -rata berat yang akan diperoleh hewan setiap hari selama periode pemberian makan ",
      carcassWeight: "Berat Bangkai ",
      weightAnimalsHideInternalOrgansRemoved:
        "Berat hewan setelah kepala, sembunyikan dan organ internal telah dihapus. ",
      weightAtCalving: "Berat saat melahirkan ",
      weightAtTheTimeOfCalving: "Berat pada saat melahirkan. ",
      yearlingWeight: "Berat bobot tahun ",
      weightYearOldAnimal: "Berat hewan berusia satu tahun. ",
      somaticCellScore: "Skor sel somatik ",
      somaticCellScoreIndicatorMastitis:
        "Skor sel somatik sebagai indikator untuk mastitis. Petani dapat mendeteksi tanda -tanda awal infeksi mastitis dengan menggunakan tes ini. SCC adalah ukuran sel tubuh dan sel darah putih yang ada dalam susu. SCC tinggi menunjukkan adanya infeksi pada ambing sapi. Tingkat SCC yang rendah (<200.000/mL) diharapkan untuk ekstraksi protein yang baik dari susu. Jumlah sel somatik terkait dengan kesehatan dan kebersihan sapi dan kebersihan kondisi perumahan. ",
      lastUpdate: "Pembaharuan Terakhir",
      bodyConditionScore: "Skor kondisi tubuh ",
      scoreAnimalFat:
        "Skor hewan sehubungan dengan berapa banyak lemak yang dimilikinya. Skor kondisi berkisar dari 1 (sapi yang sangat tipis tanpa cadangan lemak) hingga 5 (sapi yang terlalu banyak dikondisikan). Skor kondisi ideal adalah 3,0-3,25 saat kering dan melahirkan, dan 2,25-2,75 pada laktasi puncak, tanpa sapi mengubah kelas skor kondisi lebih dari 0,5-0,75 selama periode laktasi apa pun. ",
      teatScore: "Skor dot ",
      scoreMeasureingShapeTeats:
        "Skor ukuran dot adalah penilaian subyektif dengan panjang dot dan keliling dan berkisar dari 9 (sangat kecil) hingga 1 (sangat besar). Skor udder dan dot harus diambil dalam waktu 24 jam setelah melahirkan, lebih disukai oleh satu orang dan pada kuartal terlemah. ",
      udderScore: "Skor suspensi udder ",
      scoreMeasureingShapeOfUdder:
        "Bentuk pengukuran skor udder (skor 1-9). Kekuatan perlekatan ambing ke perut. Semakin ketat rongga tubuh yang ditempatkan ambing, semakin diinginkan. Ini memungkinkan anak sapi untuk menemukan dot dengan lebih mudah dan kecil kemungkinannya untuk disetor di lumpur. ",
      whetherAnimalEasyBirthDifficult:
        "Kelahiran di ternak adalah proses alami tetapi kadang -kadang mungkin ada masalah kelahiran di mana bendungan membutuhkan bantuan dari petani/penggembala. ",
      totalLongevity: "Total umur panjang ",
      survivalLactationTraitCowCulledBreeding:
        "Kelangsungan hidup dari laktasi 1 hingga 5. Sifat ini dihitung setelah sapi dimusnahkan dan diperlukan untuk estimasi nilai pemuliaan. ",
      docility: "Kepatuhan",
      circumferenceBullScrotal: "Lingkar skrotika banteng",
      intervalSuccessInsemination:
        "Interval dari pertama ke inseminasi yang berhasil. ",
      ageAtFirstCalving: "Usia pada anak sapi pertama ",
      ageCowCalving: "Berapa usia sapi di melahirkan pertama. ",
      calvingInterval: "Interval melahirkan ",
      periodCalving: "Periode dari satu melahirkan ke anak sapi berikutnya. ",
      scrotalCircumference: "Keliling skrotum ",
      estrusDetection: "Deteksi estrus ",
      trackingBehaviorAnimalDetectingEstrus:
        "Melacak perilaku gerakan hewan untuk mendeteksi estrus sapi. ",
      presenceOfEstrus: "Adanya estrus ",
      isCowInEstrusStage: "Adalah saat sapi berada di tahap estrus atau atau ",
      matureWeight: "Berat badan dewasa ",
      weightAnimalDefinedAge: "Berat hewan di zaman yang ditentukan. ",
      matureHeight: "Tinggi dewasa ",
      heightAnimalDefinedAge: "Tinggi hewan di usia yang ditentukan. ",
      footClawSet: "Set kaki cakar ",
      shapeAnimalClaw: "Bentuk cakar binatang.",
      pulmonaryArterialPressure: "Tekanan arteri paru ",
      animalBloodPreasure: "Penipuan darah hewan.",
      footAngle: "Sudut kaki ",
      shapeAnimalFoot: "Bentuk kaki binatang.",
      ribEyeArea: "Area iga ",
      amountRibEyeArea: "Jumlah area iga. ",
      ultrasoundFat: "Ultrasound Fat ",
      measureFatAmount: "Ukuran jumlah lemak. ",
      ultrasoundIntramuscularFat: "Ultrasonik lemak intramuskular ",
      ultrasoundRibEyeArea: "Area iga ultrasonik ",
      measureRibeyeArea: "Ukuran area ribeye. ",
      fatThickness: "Ketebalan lemak ",
      anmountAnimalBackFat: "Anmount lemak punggung hewan.",
      marbling: "Marbling ",
      marballingMeasurement:
        "Marbling adalah lemak intramuskular tak jenuh (sehat) yang menumpuk di dalam otot dan di antara bundel serat otot. ",
      dryMatterIntake: "Asupan kering ",
      amountFeedAnimalConsumesAMoisture:
        "Jumlah pakan yang dikonsumsi hewan per hari berdasarkan kelembaban. ",
    },
    feedsName: "Nama feed ",
    feedName: "Nama feed ",
    firstFeedQuantity: "Kuantitas pakan pertama ",
    additionalFeed: "Feed tambahan ",
    cloversRyeGrasses: "Cengkeh, rumput gandum ",
    greenFodderHayLegumes: "Pakan hijau, jerami, kacang -kacangan ",
    feedsRegisteredSuccessfully: "Feed berhasil terdaftar ",
    feedsNotRegistered: "Feed tidak terdaftar ",
    fEEDQUANTITY: "Kuantitas pakan ",
    feedQuantity: "Kuantitas pakan ",
    fEEDNAME: "Nama feed ",
    nOFEEDINFOAVAILABLE: "Tidak ada info umpan yang tersedia ",
    searchByFeedName: "Cari dengan nama umpan ",
    loadingFeedInfo: "Memuat info umpan ... tolong tunggu ",
    todayFeedInfo: "Info Umpan Hari Ini ",
    feedInfo: "Info umpan ",
    loremIpsumDolorSitAmet:
      "Lorem ipsum dolor duduk amet, elite adipiscing consectetur. UT Lacus SEM, Maximus Vitae Interdum In, konsekuensi non SEM. Morbi Posuere Dignissim Est Ut Molestie. ",
    geneticWorthInfo: {
      breedingValueEconomicIndex:
        "Apakah nilai pemuliaan ini digunakan untuk perhitungan indeks ekonomi. ",
      dailyProteinYieldUsed: "Hasil protein harian digunakan ",
      weightAssignedBreedingDailyProteinYield:
        "Berat yang ditugaskan untuk nilai pemuliaan yang sesuai dengan hasil protein harian. Bobot ini digunakan untuk perhitungan indeks ekonomi. ",
      dailyProteinYieldWeight: "Protein harian menghasilkan berat ",
      rankAnimalInRelationshipEconomicIndex:
        "Pangkat hewan dalam hubungannya dengan indeks ekonomi. ",
      economicIndexRank: "Peringkat indeks ekonomi ",
      percentileEconomicIndexFall: "Persentil indeks ekonomi mana yang jatuh. ",
      economicIndexPercentile: "Persentil Indeks Ekonomi ",
      accuracyOfEconomicIndex: "Keakuratan indeks ekonomi. ",
      economicIndexAccuracy: "Akurasi indeks ekonomi ",
      weightedAverageOfBreedingValues:
        "Rata -rata tertimbang nilai pemuliaan. ",
      economicIndex: "Indeks Ekonomi ",
      rankOfAnimalInRelationshipBreeding:
        "Pangkat hewan dalam hubungannya dengan nilai pemuliaan yang sesuai. ",
      dailyProteinYieldBreedingValueRank:
        "Protein harian menghasilkan peringkat nilai pemuliaan ",
      percentileBreedingFalls: "Persentil yang nilai pembiakannya jatuh. ",
      dailyProteinYieldBreedingPercentile:
        "Protein harian menghasilkan nilai pemuliaan persentil ",
      accuracyEstimatedBreeding: "Keakuratan estimasi nilai pemuliaan. ",
      dailyProteinYieldBreedingAccuracy:
        "Akurasi nilai pemuliaan protein harian ",
      estimatedBreedingTraitDailyProteinYield:
        "Diperkirakan nilai pemuliaan dari sifat hasil protein harian. ",
      dailyProteinYieldBreedingValue: "Nilai pemuliaan protein harian ",
      pathToTheDirectoryScriptsBreeding:
        "Jalur ke direktori pada hard drive yang berisi skrip yang digunakan untuk perhitungan nilai pemuliaan. ",
      scriptsPath: "Jalur skrip ",
      softwarePackageBreeding:
        "Paket perangkat lunak yang digunakan untuk menghitung nilai pemuliaan. ",
      breedingValueSoftware: "Perangkat lunak nilai pemuliaan ",
      methodCalculateBreeding:
        "Metode yang digunakan untuk menghitung pembiakan ",
      breedingValueMethod: "Metode nilai pemuliaan ",
      trait: "Sifat",
      tools: "Peralatan",
      geneticWorth: "Nilai genetik ",
      dailyProteinYield: "Hasil protein harian ",
      breedingValue: "Nilai pemuliaan ",
      breedingValueBIFAccuracy: "Nilai pemuliaan akurasi bif ",
      breedingValuePercentile: "Persentil Nilai Breeding ",
      breedingValueRank: "Peringkat nilai pemuliaan ",
      checkLTD: "Periksa Ltd ",
      ultrasoundDiagnostic: "Diagnostik ultrasonik ",
      selectYieldUsed: "Pilih hasil yang digunakan ",
      softwareName: "Nama perangkat lunak ",
      animalGenWorthUpdatedSuccessfully:
        "Gen hewan layak diperbarui dengan sukses ",
    },
    addNote: "Menambahkan catatan",
    enterNote: "Masukkan catatan ",
    noteIsRequired: "Catatan diperlukan ",
    noteMustBeLessThan50Characters: "Catatan harus kurang dari 50 karakter ",
    noteAdded: "Catatan ditambahkan ",
    noteNotAdded: "Catatan tidak ditambahkan ",
    noteForAnimal: "Catatan untuk hewan. ",
    noNoteFoundForThisAnimal:
      "Tidak ada catatan yang ditemukan untuk hewan ini. ",
    inseminationData: "Data inseminasi ",
    nameOfInseminator: "Nama inseminator ",
    activity: "Aktivitas",
    searchByNameActivity: "Cari dengan nama, aktivitas ",
    searchByTaskNameNumber: "Cari dengan nama tugas, nomor ",
    inseminationDate: "Tanggal Inseminasi ",
    genotypeDataInfo: {
      genotypeAnimalID: "ID hewan genotipe ",
      iDTubeBloodSampleAnimalNumberGenotypingService:
        "Ini adalah ID tabung dengan sampel darah yang diambil dari hewan atau sejumlah layanan genotipe ",
      geneticTechnicianName: "Nama Teknisi Genetik ",
      NameTechnicianBloodSamplesAnimal:
        "Ini adalah nama seorang teknisi yang mengambil sampel darah dari hewan itu ",
      sNPData: "Data SNP ",
      genotypingServiceNote: "Catatan Layanan Genotipe ",
      InfoGenotypingGenotypingTechnology:
        "Semua informasi yang berkaitan dengan genotip seperti nama perusahaan genotipe, teknologi genotipe yang digunakan, tanggal genotipe, dll ",
      numberOfSNPs: "Jumlah SNP ",
      numberOfSNPsAnimalGenotyped: "Jumlah SNP hewan itu di genotipe untuk ",
      nameOfTheDrug: "Nama obatnya ",
      animalGenoDataUpdatedSuccessfully:
        "Data geno hewan diperbarui dengan sukses ",
      animalGenoDataNotUpdated: "Data geno hewan tidak diperbarui ",
      animalIDIsRequired: "ID hewan diperlukan ",
      techNameIsRequired: "Tech. nama diperlukan ",
      onlyAlphabetsAreAllowed: "Hanya huruf yang diizinkan ",
      genoDataIsRequired: "Data geno diperlukan ",
      serviceNoteIsRequired: "Catatan layanan diperlukan ",
      sNPIsRequired: "SNP diperlukan",
    },
    healthRecordInfo: {
      treatment: "Perlakuan",
      treatmentTakenAnimal: "Perawatan apa yang diambil pada hewan. ",
      reasonOfTreatment: "Alasan perawatan ",
      reasonForTreatment: "Alasan perawatan ",
      whatReasonOfTreatment: "Apa alasan perawatan. ",
      treatmentDate: "Tanggal pengobatan ",
      dateOfTreatment: "Tanggal perawatan. ",
      diagnosis: "Diagnosa",
      nameDiagnosedDiseaseConditionSymptoms:
        "Nama penyakit/kondisi yang didiagnosis atau gejala utama ",
      drugID: "ID Obat ",
      iDOfDrugWhichIsGivenToAnimal: "Id obat yang diberikan kepada hewan. ",
      drugName: "Nama obat ",
      nameDrugAnimal: "Nama obat yang diberikan kepada hewan. ",
      drugWithdrawalPeriod: "Periode penarikan narkoba ",
      timeAdministrationDrugAnimalMeatMilkHumanConsumption:
        "Waktu yang dibutuhkan setelah pemberian obat kepada hewan untuk memastikan keamanan daging atau susu untuk konsumsi manusia ",
      attendingVeterinarian: "Menghadiri dokter hewan ",
      qualifiedPersonCaseAnimal:
        "Orang yang memenuhi syarat yang melihat kasus/hewan ",
      packID: "Pack ID ",
      iDPackTreatment: "Id dari paket yang digunakan untuk perawatan ",
      veterinarianName: "Nama dokter hewan ",
      animalNoHealthRecord:
        "Hewan ini tidak memiliki catatan kesehatan. Klik tombol di bawah ini untuk mendaftar",
      addHealthRecord: "Tambahkan catatan kesehatan ",
      healthStatus: "Status kesehatan",
      loadingDiseasesPleaseWait: "Memuat penyakit ... harap tunggu",
      animalDiseaseRecord: "Catatan Penyakit Hewan",
      animalHealthRecord: "Catatan Kesehatan Hewan",
      animalTreatmentRecord: "Catatan Perawatan Hewan ",
      loadingHealthData: "Memuat data kesehatan ...",
      healthRecord: "Catatan kesehatan",
      nameOfDiagnosis: "Nama diagnosis",
      treatmentName: "Nama perawatan",
      drugGivenBy: "Obat yang diberikan oleh",
      recessiveDiseases: "Penyakit resesif",
    },
    conceptionInfo: {
      addNewConception: "Tambahkan konsepsi baru ",
      semenEmbryo: "Semen/embrio ",
      pregnancyCheck: "Pemeriksaan kehamilan ",
      birthInfo: "Info kelahiran ",
      searchByInseminatorOrganisationBreedingConception:
        "Cari dengan nama inseminator, nama organisasi, nomor layanan pemuliaan, metode konsepsi ",
      deliveryDate: "Tanggal pengiriman",
      calfId: "ID betis ",
      birthDayOldWeight: "Berat lahir (hari tua) ",
      searchByBirthEase: "Cari dengan Kelahiran Kelahiran ",
      searchPregnancyCheckOperatorMethod:
        "Cari dengan Operator Pemeriksaan Kehamilan, Metode Pemeriksaan Kehamilan ",
      pregnancyCheckDate: "Tanggal pemeriksaan kehamilan ",
      conceptionSuccess: "Konsepsi Sukses ",
      pregnancyCheckOperator: "Operator cek kehamilan ",
      pregnancyCheckMethod: "Metode pemeriksaan kehamilan ",
      recentlyPregnant: "Baru -baru ini hamil",
      pregnancyConfirmationDate: "Tanggal Konfirmasi Kehamilan",
      pregnancyRate: "Tingkat kehamilan",
      timePeriodOfPregnancy: "Periode waktu kehamilan",
      semenProduction: "Produksi semen",
      embryoProduction: "Produksi embrio",
      semen: "air mani",
      embryoTransferDate: "Tanggal transfer embrio",
      daysOfPregnancy: "Hari -hari kehamilan",
      searchSireEmbryoSurrogate:
        "Cari dengan ID Sire, nama embrio org, breed bendungan pengganti ",
      selectDate: "Pilih Tanggal ",
      orgnisationNameContainNumber: "Nama orgnisasi tidak boleh berisi nomor ",
      selectBirthEase: "Pilih Kelahiran Kelahiran ",
      selectUnit: "Pilih unit ",
      animalConceptionAddedSuccessfully:
        "Konsepsi hewan ditambahkan dengan sukses ",
      postageCustomerName: "Nama pelanggan ongkos kirim, nama pelanggan",
      searchByPostageCustNameCustAddPostId:
        "Cari dengan ongkos kirim nama pelanggan, alamat pelanggan, ID pos",
      dateOfSemenCollection: "Tanggal Koleksi Semen",
      dateOfSemenPreparation: "Tanggal persiapan semen",
      semenMotility: "Motilitas semen",
      semenConcentration: "Konsentrasi semen",
      postageEdit: "Edit ongkos kirim",
      enterSireId: "Masukkan ID Sire",
      selectEmbryoOrganisation: "Pilih Organisasi Embrio",
      matingDateH:
        "Tanggal konsepsi, baik perkawinan alami atau inseminasi buatan.",
      inseminatorNameH:
        "Seseorang yang melakukan proses inseminasi (dokter hewan/teknisi) ",
      orgNameH:
        "Nama organisasi atau perusahaan yang menyediakan sedotan semen untuk AI ",
      brServiceNumH: "Merekam jumlah pemuliaan (mis. 1, 2, atau 3) ",
      conceptionMethodH:
        "Cara hewan yang dikandung adalah awal kehamilan, ditandai dengan pemupukan telur dengan sperma. ",
      sireIdH:
        "ID atau jumlah pendaftaran orang tua jantan dari seekor hewan, terutama seekor banteng yang disimpan untuk pembiakan atau semen sapi jantan yang digunakan untuk inseminasi buatan.",
      damIdH:
        "ID atau jumlah pendaftaran bendungan hewan-orang tua betina hewan. Dalam kasus transfer embrio, itu juga id dari bendungan yang menyumbangkan embrio untuk transfer embrio.",
      sarogatedDamH:
        "Jika hewan yang dilahirkan melalui transfer embrio. Ini adalah id ibu pembawa/seekor hewan betina yang diresapi (seperti dengan transfer embrio atau inseminasi buatan) untuk melahirkan muda di tempat hewan lain.",
      embOrgNameH: "Nama organisasi untuk embrio",
      sarogateDamBreedH: "Tanggal breed pengganti",
      sireBreedH: "Jenis breed sire (Brahman, Boran)",
      pregCheckDateH:
        "Kehamilan dapat dideteksi pada sapi sedini 30 hari menggunakan USG dan tes darah. Untuk sapi untuk diidentifikasi sebagai hamil menggunakan metode palpasi, sapi seringkali harus hamil setidaknya 35-50 hari. Ultrasonografi digunakan untuk diagnosis kehamilan pada usia kehamilan 40 - 75 hari.",
      conceptionSuccessH:
        " Pada sapi, tingkat pemupukan adalah 90% dengan tingkat melahirkan rata-rata sekitar 55%, menunjukkan kematian embrionik-janin sekitar 35% (Diskin et al., 2006). Lebih lanjut, 70 hingga 80% dari total kehilangan embrionik terjadi selama tiga minggu pertama setelah inseminasi, terutama antara hari 7 dan 16.",
      pregnancyCheckOperatorH:
        "Dokter hewan dan teknisi hewan spesialis paling umum memberikan layanan ini kepada petani. Kedua prosedur bersifat invasif dan praktisi memerlukan pelatihan ekstensif untuk melakukan prosedur dengan aman (untuk sapi dan operator) pada akurasi dan kecepatan yang cukup agar layanan layak secara ekonomi.",
      pregnancyCheckMethodH:
        "Dua metode yang paling sering digunakan untuk diagnosis kehamilan sapi adalah palpasi manual dari saluran reproduksi (per rektum) dan ultrasonografi transrektal dari saluran reproduksi",
      deliveryDateH: "Tanggal saat persalinan kelahiran terjadi",
      calfIdH: "Id anak sapi yang baru lahir",
      birthEaseH:
        "Kelahiran di ternak adalah proses alami tetapi kadang -kadang mungkin ada masalah kelahiran di mana bendungan membutuhkan bantuan dari petani/penggembala.",
      birthDayOldWeightH:
        "Berat seekor binatang di hari kelahiran atau berat burung satu hari",
    },
    all: "Semua",
    ungrouped: "Hewan yang tidak bertelur ",
    active: "Hewan yang dikelompokkan ",
  },
  dashboardS: {
    dailyActivities: "Kegiatan sehari-hari",
    pendingTasks: "Tugas yang tertunda ",
    performanceOfGeno: "Kinerja genotipe ",
    breed: "Keturunan",
    chromosome: "Kromosom",
    seqChange: "Urutan perubahan ",
    inheritance: "Warisan",
    diseaseName: "Nama penyakit ",
    refSequence: "Urutan referensi ",
    pubmedRef: "Referensi PubMed ",
    matingDate: "Tanggal kawin ",
    inseminatorName: "Nama inseminator ",
    orgName: "Nama Organisasi",
    brServiceNum: "Nomor layanan pembiakan ",
    conceptionMethod: "Metode konsepsi ",
    semEmbInfo: "Info semen/embrio ",
    sireId: "ID Sire ",
    damID: "ID bendungan ",
    srgDamId: "Surrogate Dam ID ",
    embOrgName: "Embrio org. Nama",
    srgDamBreed: "Surrogate Dam Breed ",
    sireBreed: "Breed sire ",
    damBreed: "Breed bendungan",
  },
  user: {
    selectLanguage:"Pilih bahasa",
    unitPreference:"Preferensi Satuan",
    selectUnitOfMeasure:"Pilih satuan ukuran",
    importedUser: "Pengguna yang Diimpor",
    impFileStatus: "Impor Status Berkas",
    loadingUser: "Memuat Pengguna... Harap tunggu",
    totalUsers: "Jumlah Pengguna",
    pendingUsers: "Pengguna Tertunda",
    changePassword: "Ganti kata sandi",
    goodIdeaToUsePassword:
      "Sebaiknya gunakan kata sandi yang kuat yang tidak Anda gunakan di tempat lain.",
    enterCurrentPassword: "Masukkan Kata Sandi Saat Ini",
    enterNewPassword: "Masukan kata sandi baru",
    reEnterPassword: "Masukkan Ulang Kata Sandi Baru",
    enterPassword: "Masukkan kata kunci",
    repeatNewPassword: "Ulangi Kata Sandi Baru",
    emailAddr: "Alamat email",
    enterYourPhoneNumber: "Masukkan Nomor Telepon Anda",
    pleaseTypeOldPassword: "Silakan ketik kata sandi lama.",
    pleaseTypeNewPassword: "Silakan ketik kata sandi baru.",
    pleaseTypeConfirmPassword: "Silahkan ketik konfirmasi kata sandi.",
    passwordChangedSuccesFully: "Kata sandi berhasil diubah",
    currentPassword: "kata sandi saat ini",
    newPassword: "kata sandi baru",
    passwordDoesNotMatch: "Kata sandi tidak cocok.",
    emailCanNotBeEmpty: "Email tidak boleh kosong",
    profileUpdated: "Profil diperbarui",
    profileNotUpdated: "Profil Tidak Diperbarui",
    unableToVerifyEmail: "Tidak dapat memverifikasi Email",
    otpSentOnEmail: "OTP dikirim melalui email",
    otpSentSuccessFully: "OTP berhasil dikirim",
    importUsers: "Impor Pengguna",
    imageUpdated: "Gambar Diperbarui",
    departmentName: "nama departemen",
    departmentNum: "Nomor Departemen",
    departmentAdded: "Departemen Ditambahkan",
    departmentNotAdded: "Departemen tidak Ditambahkan",
    searchDepartnment: "Cari Berdasarkan Nama Departemen Atau Nomor",
    addDepartMent: "Tambahkan Departemen",
    addDepartment: "Tambahkan Departemen",
    roleNameIsRequired: "Nama peran wajib diisi",
    roleNameMustBeLessThan15Chars: "Nama peran harus kurang dari 15 karakter",
    roleAdded: "Peran Ditambahkan",
    editDepartment: "Sunting Departemen",
    departmentUpdated: "Departemen Diperbarui",
    departmentNotUpdated: "Departemen Tidak Diperbarui",
    deleteDepartment: "Hapus Departemen",
    deleteDepartmentMessage:
      "Apakah Anda yakin ingin menghapus departemen ini.",
    noRoleAvailable: "TIDAK ADA PERAN YANG TERSEDIA",
    roleUpdated: "Peran Diperbarui",
    roleNotUpdated: "Peran Tidak Diperbarui",
    editRole: "Sunting Peran",
    allRole: "Semua Peran",
    addNewRole: "Tambahkan Peran Baru",
    allDepartment: "Semua Departemen",
    permissionsUpdated: "Izin Diperbarui",
    permissionsnotUpdated: "Izin tidak Diperbarui",
    roleNo: "Peran No.",
    searchByEmailAndName: "Cari berdasarkan email dan nama",
    userID: "identitas pengguna",
    userUpdated: "Pengguna Diperbarui",
    userNotUpdated: "Pengguna Tidak Diperbarui",
    userAdded: "Pengguna Ditambahkan",
    userNotAdded: "Pengguna Tidak Ditambahkan",
    activateUser: "Aktifkan Pengguna",
    deactivateUser: "Nonaktifkan Pengguna",
    userStatusMsg: "Apakah Anda yakin ingin mengubah status pengguna",
    countryRequired: "Negara diperlukan",
    stateRequired: "Negara diperlukan",
    cityRequired: "Kota diperlukan",
    searchByRole: "Cari Berdasarkan Nomor Peran, Nama Peran, Departemen",
    noModuleAvailable: "Tidak Ada Modul yang Tersedia",
    searchBYModuleName: "Cari Berdasarkan Nama Modul",
  },
  farm: {
    farmID: "ID pertanian",
    onTheFarm: "Di Peternakan",
    userRoles: "Peran Pengguna",
    adduser: "Tambahkan pengguna",
    addAuser: "Tambahkan Pengguna",
    uploadUsers: "Unggah Pengguna",
    addNewUser: "Tambahkan pengguna baru",
    selectDept: "Pilih Departemen",
    selectRole: "Pilih Peran",
    editUser: "Sunting Pengguna",
    totalFarms: "Peternakan Total",
    NoAnimalsRegisteredForthisFarm:
      "Tidak ada Hewan yang Terdaftar untuk Peternakan ini",
    farmsPerPage: "Peternakan per halaman",
    regularFarms: "Peternakan Reguler",
    farmRegisteredProducts: "Produk Terdaftar Peternakan",
    searchByFarmNameAndId: "Cari berdasarkan Nama Pertanian dan Id",
    loadingProductsPleaseWait: "Memuat Produk... Harap tunggu",
    farmName: "Nama Peternakan",
    farmLocation: "Lokasi Peternakan",
    productName: "Nama Produk",
    stockStatus: "Status stok",
    inStock: "Persediaan",
    searchByProductName: "Cari Berdasarkan Nama Produk",
    productCategory: "Kategori Produk",
    products: "Produk",
    farms: "Peternakan",
    registerAfarm: "Daftarkan Peternakan",
    govtRegistry: "Pemerintah ",
    cooperativeID: "ID Koperasi",
    farmType: "Jenis Peternakan",
    contractMating: "Perkawinan Kontrak",
    customization: "Kustomisasi",
    recordsPerpage: "Rekaman per Halaman",
    restoreDefault: "Kembali ke awal",
    apply: "Menerapkan",
    searchState:
      "Cari berdasarkan ID Peternakan, Registri Gubernur, ID Koperasi, Jenis Peternakan, Perkawinan Kontrak",
    farmOwner: "Pemilik Peternakan",
    govRegistrationNo: "Nomor Registrasi Pemerintah",
    farmInformation: "Informasi Peternakan",
    ownershipType: "Jenis Kepemilikan",
    communityName: "Nama komunitas",
    farmLicenseInformation: "Informasi Izin Peternakan",
    licenseNumber: "Nomor lisensi",
    licenseExpiryDate: "Tanggal Kedaluwarsa Lisensi",
    regulatorName: "Nama Pengatur",
    regulatorRepresentativeName: "Nama Perwakilan Regulator",
    farmLocationSize: "Lokasi Peternakan",
    productionSystem: "Sistem produksi",
    country: "Negara",
    state: "Negara",
    city: "Kota",
    street: "Jalan",
    houseNumber: "Nomor rumah",
    farmRegistration: "Pendaftaran Peternakan",
    cancel: "Membatalkan",
    register: "Daftar",
    ok: "Oke",
    totalFarmSize: "Ukuran Lahan Total",
    farmGeographicLocation: "Lokasi Geografis Peternakan",
    perimeterPointLongitude: "Bujur Titik Perimeter",
    perimeterPointLatitude: "Lintang Titik Perimeter",
    perimeterPointLabel: "Label Titik Perimeter",
    perimeterLength: "Panjang Perimeter",
    farmLatitude: "Lintang Ladang",
    farmLongitude: "Bujur Ladang",
    editFarm: "Sunting Peternakan",
    update: "Memperbarui",
    editAfarm: "Mengedit sebuah peternakan",
    nextFarm: "Peternakan Selanjutnya",
    nameoftheFarm: "Nama Peternakan",
    registerAProduct: " Daftarkan Produk",
    farmProducts: "Produk Pertanian",
    calf: "Anak sapi",
    steer: "Steer",
    heifer: "Sapi muda",
    sire: "Bapak",
    dam: "Bendungan",
    registerAnAnimal: "Daftar Hewan",
    farmAnimals: "Hewan ternak",
    farm_type: "Jenis pertanian",
    farm_Owner: "Pemilik Peternakan",
    dateOfRegistration: "Tanggal Pendaftaran",
    dataIsNotAvailableForThisFarm: "Data Tidak tersedia untuk Peternakan ini",
    registerNewProduct: "Daftarkan Produk Baru",
    information: "Informasi",
    licenseInfo: "Info Lisensi",
    locationInfo: "Info Lokasi",
    geoLocation: "Lokasi Geo",
    perimeterLengthState: "Panjang Perimeter Kebun (panjang pagar)",
    totalFarmSizeState: "Ukuran Peternakan",
    productionSystemState: "Sistem Produksi yang digunakan di Farm",
    contractMatingState:
      "Kode Program Perkawinan Kontrak di mana Peternakan Berpartisipasi.",
    ownershipTypeState: "Jenis kepemilikan",
    regulatorRepresentativeNameState:
      "Nama orang yang mewakili regulator yang mengeluarkan lisensi",
    regulatorNameState: "Nama regulator yang mengeluarkan lisensi",
    licenseExpiryDateState: "Tanggal ketika Lisensi saat ini Kedaluwarsa",
    licenseNumberState: "Nomor Lisensi yang dikeluarkan oleh Regulator",
    plotNumberState: "Nomor rumah peternakan.",
    plotNumber: "Nomor Rumah/Kavling",
    streetStatement: "Nama jalan peternakan.",
    cityStatement: "Kota tempat peternakan itu berada.",
    stateStatement: "Wilayah negara tempat peternakan berada.",
    countryState: "Negara tempat peternakan itu berada.",
    perimeterPointLongitudeState: "Bujur satu titik di pertanian.",
    perimeterPointLatitudeState: "Garis lintang satu titik di pertanian.",
    perimeterPointLabelState: "Label Titik.",
    farmLongitudeState: "Bujur pertanian.",
    farmLatitudeState: "Garis lintang pertanian.",
    farmNameH: "Nama peternakan",
    farmTypeH: "Jenis peternakan di mana kegiatan yang berbeda dilakukan.",
    farmOwnerH:
      "Nama pemilik peternakan (menghasilkan otomatis nama Petani memasukkan info)",
    ownershipTypeH:
      "Tipe petani yang memiliki/menguasai lahan yang diusahakannya dan yang tidak.",
    govtRegNumbH: "Nomor pendaftaran peternakan yang ditugaskan oleh regulator",
    contractMatingH: "Kode program kawin kontrak yang diikuti oleh tambak",
    productionSystemH: "Sistem produksi apa yang digunakan di peternakan",
    cooperativeIDH: "ID koperasi tempat pertanian menjadi anggotanya ",
    licenseNumberH:
      "Nomor identifikasi pada lisensi yang dikeluarkan oleh regulator yang mengidentifikasinya dengan pemilik.",
    licenseExpiryDateH: "Tanggal ketika lisensi saat ini kedaluwarsa",
    regularNameH: "Nama regulator yang mengeluarkan lisensi",
    regularRepName:
      "Nama orang yang mewakili regulator yang mengeluarkan lisensi",
    countryH: "Negara tempat peternakan itu berada.",
    stateH: "Wilayah negara tempat peternakan berada.",
    cityH: "Kota tempat peternakan itu berada.",
    streetH: "Nama jalan peternakan.",
    houseNumberH: "Nomor rumah peternakan.",
    totalFarmSizeH:
      "Ukuran kebun adalah jumlah tanah yang saat ini ditanami oleh kebun termasuk tanah yang diberakan tetapi tidak termasuk tanah di bawah vegetasi alami, pohon atau padang rumput.",
    farmLatitudeH: "Apakah pengukuran jarak utara atau selatan Khatulistiwa. ",
    farmLongitudeH: "Ini mengukur jarak timur atau barat dari meridian utama.",
    perimeterLengthH: "Panjang perimeter peternakan (panjang pagar)",
    perimeterPointLabelH: "Label titik. ",
    perimeterPointLatH: "Garis lintang satu titik di pertanian",
    perimeterPointLongH: "Bujur satu titik di pertanian",
    noProductAvailable: "Tidak Ada Produk yang Tersedia",
    farmUpdated: "Peternakan Diperbarui",
    performance: "Pertunjukan",
    milkInformation: "Informasi Susu",
    farmNameRequired: "Nama Peternakan wajib diisi",
  },
  login: {
    welcome: "Selamat datang! Gabung",
    welInfo: "Masukkan kredensial Anda. ",
    login: "Gabung",
    forgotPassword:"Tidak ingat kata sandi",
    forgotPasswordDesc:"Masukkan alamat email yang terkait dengan akun Anda. Detail kata sandi akan dikirim ke alamat email Anda.",
    backToLogin:"Kembali untuk masuk",
  },
  actionListmod: {
    actionList: "Daftar aksi",
    tODAY: "Hari ini",
    createTask: "Buat tugas",
    myActivities: "Aktifitas saya",
    jhonSmith: "Jhon Smith",
    farmID: "ID pertanian",
    dateOfEvent: "Tanggal acara",
    actionRequired: "Tindakan diperlukan",
    actionTaken: "Tindakan yang diambil",
    animalEventID: "ID Acara Hewan",
    cANCEL: "Membatalkan",
    cONFIRM: "Mengonfirmasi",
    sTATEMENT: "Apakah Anda yakin ingin menghapus catatan ini?",
    dAY: "Hari",
    wEEK: "Pekan",
    mONTH: "Bulan",
    sUBMIT: "Kirim",
    startDate: "Mulai tanggal",
    endDate: "Tanggal akhir",
    rEPEAT: "Mengulang",
    taskCategory: "Kategori tugas",
    pRIORITY: "Prioritas",
    aSSIGNEE: "Penugasan",
    selectLocation: "Pilih lokasi",
    selectAnimals: "Pilih satu atau lebih hewan",
    dESCRIPTION: "Keterangan",
    customRecurrence: "Kekambuhan Kustom",
    repeatEvery: "Ulangi setiap",
    taskName: "Nama tugas",
    enterDescription: "Masukkan deskripsi",
    toDo: "Melakukan",
    assignTo: "Ditugaskan kepada",
    status: "Status",
    nOTE: "Catatan",
    noTaskAvailable: "Tidak ada tugas yang tersedia",
    healthRecord: "Catatan kesehatan",
    iD: "PENGENAL",
    tAG: "Menandai",
    dateOfbirth: "Tanggal lahir",
    taskTakenat: "Tugas yang diambil",
    gENDER: "Jenis kelamin",
    bREED: "Keturunan",
    regDate: "Reg. Tanggal",
    updateHealthRecord: "Perbarui Catatan Kesehatan untuk Hewan",
    treatment: "Perlakuan",
    reasonOftreatment: "Alasan perawatan",
    treatmentDate: "Tanggal pengobatan",
    dIAGNOSIS: "Diagnosa",
    drugId: "ID obat",
    drugName: "Nama obat",
    drugWithdrawalperiod: "Periode penarikan narkoba",
    attendingVeterinarian: "Menghadiri dokter hewan",
    packId: "ID paket",
    noItemsselected: "Tidak ada item yang dipilih",
    healthRecordsubmission: "Pengajuan Catatan Kesehatan",
    inseminationRecordsubmission: "Pengajuan Rekor Inseminasi",
    inseminatorName: "Nama inseminator",
    inseminatorId: "ID inseminator",
    conceptionRate: "Tingkat konsepsi",
    dateOfmeasurement: "Tanggal pengukuran",
    recordSubmission: "Rekam Pengajuan",
    uPDATE: "Memperbarui",
    updateTask: "Perbarui tugas",
  },
  inseminatorStatisticsInfo: {
    addInseminatorInfo: "Tambahkan Info Inseminator ",
    inseminatorNumber: "Nomor inseminator ",
    loadingInseminatorPleaseWait: "Memuat Inseminator ... Harap Tunggu ",
    searchByIDAndName: "Cari dengan ID dan Nama ",
    inseminatorInfoAdded: "Info inseminator ditambahkan ",
    inseminatorInfoNotAdded: "Info inseminator tidak ditambahkan ",
    inseminatorInfoUpdated: "Info inseminator diperbarui ",
    inseminatorInfoNotUpdated: "Info inseminator tidak diperbarui ",
    editAInseminatorInfo: "Edit Info Inseminator ",
    inseminatorList: "Daftar Inseminator ",
    inseminatorInfoDetails: "Detail info inseminator ",
    updateInseminatorInfo: "Perbarui Info Inseminator ",
  },
  organizationNtrInfo: {
    loadingOrdersPleaseWait: "Memuat pesanan ... tolong tunggu ",
    addStocks: "Tambahkan stok ",
    addStock: "Tambahkan stok ",
    quantity: "Kuantitas",
    selectUnit: "Pilih Unit ",
    farmProducts: "Produk pertanian ",
    cost: "Biaya",
    transactionID: "ID transaksi",
    recipientID: "ID penerima ",
    orderID: "Id pemesanan",
    recepientName: "Nama recepient ",
    createAOrder: "Buat pesanan ",
    totalStocks: "Total stok ",
    orders: "Pesanan ",
    totalPending: "Total tertunda ",
    totalDelivered: "Total dikirim ",
    searchByRecepientNameOrderIdRecepientId:
      "Cari dengan nama recepient, ID pesanan, ID Recepient ",
    chooseTheDate: "Pilih tanggal ",
    transactionDate: "Tanggal transaksi",
    selectCategory: "Pilih Kategori",
    volumeOfProduct: "Volume produk ",
    productQuantity: "Kuantitas produk ",
    productRecipientId: "ID penerima produk ",
    productRecipientName: "Nama penerima produk ",
    productRecipientType: "Tipe penerima produk ",
    singleProduct: "Produk tunggal ",
    orderPlaced: "Pesanan ditempatkan ",
    orderNotPlaced: "Pesanan tidak ditempatkan ",
    totalPrice: "Total harga",
    currency: "Mata uang",
    selectCurrency: "Pilih Mata Uang",
    address: "Alamat",
    enterAddress: "Masukkan alamat",
    attachments: "Lampiran ",
    chooseFile: "Pilih File",
    nameOfTheFarm: "Nama pertanian ",
    loremIpsumHasBeenTheIndustrySStandardDummyText:
      "Lorem Ipsum telah menjadi teks dummy standar industri sejak tahun 1500 -an, ketika printer yang tidak diketahui mengambil",
    billedTo: "Ditagih ke ",
    orderStatus: "Status pemesanan",
    selectStatus: "Pilih Status ",
    cadbury: "Cadbury ",
    totalAmount: "Jumlah total",
    deliveryCharges: "Ongkos kirim",
    orderDetails: "Detail pesanan",
    deliveryOnTime: "Pengiriman tepat waktu ",
    productID: "ID Produk",
    productRegistration: "Registrasi produk",
    enterTheNameOfTheProduct: "Masukkan nama produk ",
    nameOfTheProduct: "Nama produk ",
    productAdded: "Produk ditambahkan ",
    productNotAdded: "Produk tidak ditambahkan",
  },
  drug: {
    dRUGS: "Narkoba",
    registerAdrug: "Daftarkan obat",
    sEARCH: "Mencari",
    genericName: "Nama generik",
    manufacturer: "Pabrikan",
    distributor: "Distributor",
    registrationDate: "Tanggal registrasi",
    drugRegistration: "Pendaftaran narkoba",
    drugInformation: "Informasi narkoba",
    packExpiration: "Kemas kedaluwarsa",
    drugId: "ID obat",
    drugName: "Nama obat",
    drugGenericname: "Nama generik obat",
    drugManufacturer: "Produsen obat",
    distributorName: "Nama distributor",
    drugRegistrationdate: "Tanggal pendaftaran narkoba",
    nextDrug: "Obat berikutnya",
    editDrug: "Edit obat",
    updateDrug: "Perbarui Obat",
    deleteDrug: "Hapus obat",
    noRecordfound: "Tidak ada catatan yang ditemukan",
    addDrug: "Tambahkan obat",
    statementDrug:
      "Obat telah dihapus. Klik tombol di bawah ini untuk mendaftar. ",
    cANCEL: "Membatalkan",
    cONFIRM: "Mengonfirmasi",
    sTATEMENT: "Apakah Anda yakin ingin menghapus catatan ini?",
    ok: " Oke",
    information: "Informasi",
    packOrder: "Pesanan paket",
    packPrescription: "Resep resep",
    packReservation: "Paket reservasi",
    packLocation: "Lokasi paket",
    drugDozedam: "Dosis narkoba dalam sehari untuk bendungan",
    drugDozecalf: "Dosis narkoba dalam sehari untuk anak sapi",
    drugFormate: "Format obat",
    drugDistributor: "Distributor narkoba",
    drugActiveingridents: "Bahan aktif narkoba",
    drugSubstitutionId: "ID substitusi obat",
    packId: "ID paket",
    packBatchNumber: "Paket nomor batch",
    drugIdStatement: "Jumlah batch obat.",
    drugNameSatement: "Nama merek yang diiklankan di mana obat itu dijual.",
    drugGenericnameStatement:
      "Susunan bahan kimia obat daripada nama merek yang diiklankan di mana obat tersebut dijual.",
    drugFormateSatement: "Jumlah batch obat.",
    drugDozecalfSatement: "Untuk mengetahui jumlah dosis obat untuk anak sapi",
    drugDozedamStatement: "Untuk mengetahui jumlah dosis obat untuk bendungan.",
    drugManufacturerStatement: "Detail produsen obat.",
    drugDistributorStatement: "Detail distributor obat.",
    drugRegistrationdateStatement:
      "Tanggal pendaftaran obat di negara tertentu.",
    drugActiveingridentsStatement: "Daftar bahan aktif.",
    drugSubstitutionIdStatement:
      "ID kemungkinan pengganti untuk obat dalam kasus obat utama saat ini tidak tersedia.",
    packIdStatement: "Kode batang atau id RF dari paket.",
    packBatchNumberStatement:
      "Nomor batch yang ditetapkan untuk paket oleh pabrikan.",
    locationWarehouseID: "ID Gudang Lokasi",
    locationWarehouseIDState: "Id gudang tempat paket disimpan.",
    locationRackID: "ID rak lokasi",
    locationRackIDStatement: "Id dari rak tempat paket disimpan.",
    locationTierID: "Lokasi ID Tier",
    locationTierIDStatement: "Id dari tingkat di rak tempat paket disimpan.",
    locationPositionID: "ID posisi lokasi",
    locationPositionIDStatement: "ID posisi di tingkat tempat paket disimpan.",
    storageTemperatureCondition: "Kondisi suhu penyimpanan",
    storageTemperatureConditionStats: "Kondisi penyimpanan paket.",
    containerForm: "Bentuk wadah",
    containerFormStatement: "Bentuk wadah di mana obat dikemas.",
    consistQuantity: "Terdiri dari kuantitas",
    consistQuantityStatement: "Jumlah pil, botol, dll dalam paket.",
    releaseId: "ID rilis",
    releaseIdStatement: "Id yang ditugaskan setelah paket diambil oleh petani.",
    releaseDate: "Tanggal rilis",
    releaseDateStatement: "Tanggal ketika paket diambil dari stok oleh petani.",
    packManufacturedDate: "Paket tanggal yang diproduksi",
    packManufacturedDateStatement: "Tanggal saat paket diproduksi.",
    packImportedDate: "Paket tanggal impor",
    packImportedDateStatement: "Tanggal saat paket diimpor.",
    packExpirationDate: "Tanggal Paket Kedaluwarsa",
    packExpirationDateStatement: "Tanggal saat paket kedaluwarsa.",
    expiredSoonFlag: "Bendera Segera Kedaluwarsa",
    expiredSoonFlagState: "Peringatan tentang paket segera berakhir.",
    packTotalVolumeLeft: "Kemas volume total tersisa",
    packTotalVolumeLeftState:
      "Jumlah total paket dengan bahan yang sama tersisa dalam stok.",
    packOrderID: "ID pesanan paket",
    packOrderIDState:
      "ID yang ditugaskan setelah memesan paket dari distributor.",
    packQuantityOrdered: "Kuantitas kemasan yang dipesan",
    packQuantityOrderedState: "Jumlah paket yang dipesan dari distributor.",
    packPrice: "Harga paket",
    packPriceStatement: "Harga paket.",
    priceCurrency: "Harga Mata Uang",
    packPricecurrency: "Paket Mata Uang Harga",
    packPricecurrencyState: "Nama mata uang di mana harga dinominasikan.",
    packPaydate: "Tanggal Paket Bayar",
    payDate: "Tanggal Pembayaran",
    packPaydateState: "Tanggal ketika pembayaran dirilis ke distributor.",
    packShippingID: "ID Pengiriman Kemas",
    shippingID: "ID pengiriman",
    packShippingIdState: "ID pengiriman paket saat tiba dari distributor.",
    packShippingDate: "Tanggal pengiriman paket",
    shippingDate: "Tanggal pengiriman",
    packShippingDateState: "Tanggal kedatangan paket di stok.",
    packOrderStatus: "Kemas status pesanan",
    packOrderStatusState: "Status pesanan saat ini.",
    recepientKeeperId: "ID Penjaga Recepient",
    recepientKeeperIdStatement: "Nama individu/organisasi yang menerima paket.",
    recepientFarmId: "ID Pertanian Recepient",
    recepientFarmIdStatement:
      "ID dari pertanian di mana obat animlal mencetak ulang.",
    recepientAnimalId: "ID Hewan Recepient",
    recepientAnimalIdState: "Id hewan yang diresepkan oleh hewan (paket).",
    specialistComments: "Komentar Spesialis",
    specialistCommentsState: "Komentar spesialis/dokter hewan tentang resep.",
    specialistName: "Nama spesialis",
    specialistNameState:
      "Nama spesialis/dokter hewan yang meresepkan obat itu.",
    specialistID: "ID spesialis",
    specialistIDState: "Id spesialis/dokter hewan yang meresepkan obat itu.",
    reservedByKeeperId: "Dicadangkan dengan ID Penjaga",
    reservedByKeeperIdState: "ID penjaga yang memesan paket.",
    reservedByFarmId: "Dicadangkan dengan ID pertanian",
    reservedByFarmIdState: "ID pertanian yang memesan paket.",
    reservationTimeoutDate: "Tanggal batas waktu reservasi",
    reservationTimeoutDateState:
      "Tanggal ketika reservasi akan dibatalkan secara otomatis jika paket tidak dibeli.",
    reservationTimeout: "Timeout reservasi",
    reservationTimeoutState:
      "Jumlah jam setelah itu reservasi akan dibatalkan secara otomatis jika paket tidak dibeli atau diambil",
    reservationDate: "Tanggal reservasi",
    reservationDateState: "Tanggal reservasi paket.",
    reservationStatus: "Status reservasi",
    reservationStatusState:
      "Status reservasi paket. Paket tidak tersedia untuk orang lain jika dicadangkan.",
    loadingDrugsPleaseWait: "Memuat obat ... tolong tunggu",
    quantityOrder: "Urutan kuantitas",
    keeperID: "ID penjaga",
    timeoutDate: "Tanggal batas waktu",
    warehouseID: "ID gudang",
    rackID: "ID rak",
    tierID: "ID Tier",
    positionID: "ID posisi",
    temperatureCondition: "Kondisi suhu",
    manufactureDate: "Tanggal pembuatan",
    importedDate: "Tanggal impor",
    totalVolumeLeft: "Total volume tersisa",
  },
  reports: {
    myReports: "Laporan saya",
    satelliteReports: "Laporan satelit",
    weatherReports: "Laporan cuaca",
    pregnancyAnalytics: "Analisis Kehamilan",
    semenEmbroyAnalytics: "Analisis Semen/Lembaga",
    semenAnalytics: "Analisis Semen",
    embryoAnalytics: "Analitik embrio",
    calfAnalytics: "Analisis betis",
    milkProduction: "Produksi susu",
    totalMilkType: "Total Jenis Susu",
    totalAnimalAnalytics: "Total analitik hewan",
    animalAnalytics: "Analitik hewan",
    analyticsAndReporting: "Analitik dan pelaporan",
    filterByCountry: "Filter berdasarkan negara",
    filterByFarm: "Filter berdasarkan pertanian",
    filterByRegion: "Filter demi wilayah",
    filterByMonth: "Filter berdasarkan bulan",
    filterByDate: "Filter berdasarkan tanggal",
    filterByRole: "Filter berdasarkan peran",
    filterByYear: "Filter demi tahun",
    filterByTrait: "Filter berdasarkan sifat",
    avgBreedingValue: "Nilai pemuliaan rata -rata",
    avgEconomicIndex: "Indeks ekonomi rata -rata",
    breederReport: "Laporan Peternak",
    semenTransferDate: "Tanggal transfer semen",
    semenEmbryoProductionReport: "Laporan Produksi Semen/Embrio",
    semenProducts: "Produk semen",
    meatProducts: "Produk daging",
    totalProducts: "Total produk",
    semenEmbryoReport: "Laporan Semen/Embrio",
    numOfStraws: "Jumlah sedotan",
    collectionDate: "Tanggal Koleksi",
    productionReport: "Laporan produksi",
    receipientId: "ID penerima",
    embryoId: "ID embrio",
    semenStrawId: "ID jerami semen",
    dataScientist: "Ilmuwan Data",
    dataScientistReport: "Laporan Data Ilmuwan",
    productReport: "Laporan Produk",
    dairyProducts: "Produk susu",
  },
  genoPerformance: {
    performanceOfGenoType: "Kinerja genotipe",
    addAGenoType: "Tambahkan genotipe",
    breedName: "Nama breed",
    chromosome: "Kromosom",
    sequenceChange: "Perubahan urutan",
    inheritance: "Warisan",
    diseaseName: "Nama penyakit",
    referenceSequence: "Urutan referensi",
    pubmedReference: "Referensi PubMed",
    genoTypeRegistration: "Pendaftaran genotipe",
    breed: "Keturunan",
    editAGenoType: "Edit genotipe",
    editGenoType: "Edit genotipe",
    loadingGene: "Memuat Geno ... Harap tunggu",
    geneTypeList: "Daftar genotipe",
  },
  reportings: {
    conception: "Konsepsi (ilmuwan data)",
    performanceOfGenoData: "Kinerja genotipe (Data Scientist)",
    totalInsemination: "Inseminasi total",
    embryo: "Embrio",
    animalVaccinationRecord: "Catatan Vaksinasi Hewan",
    dataNotAvailable: "Data tidak tersedia untuk pertanian ini.",
    pregnancyStatus: "Status kehamilan",
    healthReport: "Laporan kesehatan",
    heavyMilk: "Susu berat",
    standardMilk: "Susu standar",
  },
  sidebar: {
    healthAnalytics: "Analisis Kesehatan",
    productionAnalytics: "Analisis produksi",
  },
  epd: {
    regNo:
      "Hewan reg no adalah kode unik yang diberikan kepada hewan menggunakan sarana penandaan, memastikan proses yang dilakukan untuk mengidentifikasi dan melacak hewan tertentu",
    internationalID: "ID internasional hewan",
    location: "Negara / wilayah kelahiran hewan",
    animalName: "Nama standar / nomenklatur hewan",
    gender: "Jenis kelamin hewan (pria/betina)",
    additionalIDMethod:
      "Metode apa yang digunakan untuk mengidentifikasi hewan (mis. Tag, tato)",
    damID:
      "ID atau jumlah pendaftaran bendungan hewan-orang tua betina dari hewan/id dari jumlah ibu kandung",
    sireId:
      "ID atau jumlah pendaftaran orang tua jantan dari seekor hewan, terutama seekor banteng yang disimpan untuk pembiakan atau semen sapi jantan yang digunakan untuk inseminasi buatan.",
    dateOfBirth: "Tanggal lahir hewan.",
    breederHerdCode:
      "Kode kawanan peternak yang sebagian besar diberikan oleh asosiasi peternak",
    seasonofBirth: "Musim kelahiran hewan yang dicatat dalam sebulan bijaksana",
    birthYear: "Tahun hewan yang lahir",
    birthManagementCode:
      "Kode manajemen kelahiran sebagian besar disediakan oleh pengguna/petani",
    birthSex: "Jenis kelamin hewan (jantan/betina)",
    birthWeight: "Berat lahir betis",
    primaryBreed: "Kontribusi genetik % utama hewan",
    secondaryBreed: "Kontribusi genetik % minor dari hewan",
    breedComposition: "Persentase komposisi breed mengacu pada representasi proporsional dari breed yang berbeda dalam susunan genetik hewan individu atau kelompok hewan. ",
    conceptionMethod:
      "Bagaimana hewan itu dikandung (perkawinan alami/ inseminasi/ transfer embrio).",
    accuracyWeight: "Berat akurasi",
    damAge: "Usia bendungan dalam beberapa bulan/tahun mis. 2 tahun, 24 bulan",
    weaningWeight: "Menyapih berat seekor binatang pada saat menyapih.",
    weaningDate: "Tanggal hewan mana yang disapih",
    weaningSex:
      "Jenis kelamin hewan yang disapih. Jumlah karakteristik yang membedakan organisme berdasarkan fungsi reproduksi mereka.",
    managementPastureCode:
      "Kode yang diberikan kepada manajemen/ padang rumput oleh pengguna/ petani",
    creep:
      "Makanan creep adalah praktik menyediakan pakan tambahan (biji -bijian atau hijauan) untuk anak sapi keperawatan.",
    weaningContemporaryGroupCode: "Kode Weaning Weight Group Kontemporer",
    birthContemporaryCode: "Kode Kontemporer Lahir",
    yearlingDate: "Tanggal hewan satu tahun atau pada tahun kedua usianya",
    managementFeedUnitCode:
      "Kode yang diberikan kepada unit manajemen/ umpan oleh pengguna",
    yearlingSex: "Jenis kelamin hewan pada saat bertahun -tahun",
    yearlingWeight:
      "Bobot tahunan adalah pengukuran pertumbuhan langsung pasca penyapihan dan sering digunakan untuk mencerminkan kinerja potensial keturunan yang terikat pasar di tempat pemberian pakan, diukur dalam pon betis.",
    yearlingHeight: "Tinggi hewan pada saat bertahun -tahun",
    yearlingWeightContemporaryGroupCode:
      "Kode Bobot Kontemporer Berat Badan Tahun",
    weaningYearlingWeightContemporaryGroupCode:
      "Kode penyapihan atau berat badan kontemporer berat badan",
    daysOnFeed:
      "Jumlah hari yang diumpankan dengan feed mantan khusus:ernak muda yang tumbuh diberi makan makanan berenergi tinggi untuk menghasilkan daging sapi yang dapat dipasarkan dengan biaya keuntungan yang rendah. Tergantung pada berat badan awal dan usia ternak, periode pemberian makan bervariasi dari 60 hari hingga 12 bulan",
    managementFeedUnitPenCode:
      "Kode yang diberikan kepada unit manajemen/ umpan/ pena oleh pengguna",
    harvestDate: "Tanggal hewan disembelih (terbunuh) untuk daging",
    gradingDate: "Tanggal bangkai dinilai sesuai dengan kriteria tertentu",
    carcassSex: "Jenis kelamin bangkai",
    dateonFeed:
      "Tanggal hewan itu dialihkan ke feed baru:oung Growing CA = (Ttle diberi makan makanan berenergi tinggi untuk menghasilkan daging sapi yang dapat dipasarkan dengan biaya penguatan yang rendah. Bergantung pada berat badan awal dan usia sapi, periode Memberi makan bervariasi dari 60 hari hingga 12 bulan",
    KPH: "% KPH adalah persentase dari total lemak yang ditemukan di rongga tubuh bangkai khusus di daerah ginjal, panggul, dan jantung. Sering diperkirakan secara visual oleh siswa kelas USDA atau dapat dihitung berdasarkan perubahan berat karkas setelah menghilangkan lemak dari area ini pada bangkai. Sebagian besar bangkai memiliki 1 hingga 4 persen kph. Ini adalah faktor terakhir yang digunakan untuk menentukan tingkat hasil.",
    carcassWeight:
      "Berat karkas adalah berat panas atau tidak terkena setelah panen dan pengangkatan kulit, kepala, saluran pencernaan, dan organ internal. Kadang -kadang dilaporkan sebagai berat karkas panas (HCW). Berat karkas adalah faktor utama dalam menentukan nilai karkas ketika sapi dijual berdasarkan berat berpakaian atau pada jaringan berbasis nilai.",
    fatThickness:
      "Ketebalan lemak diukur dalam inci menggunakan penguasa kecil. Tempat yang tepat untuk mengukur ketebalan backfat adalah ¾ dari panjang ke atas ribeye dari ujung tulang punggung, tegak lurus terhadap permukaan luar karkas.",
    marbling:
      "Marbling adalah lemak intramuskular tak jenuh (sehat) yang menumpuk di dalam otot dan di antara bundel serat otot.",
    ribeyeArea:
      "Jumlah iga (loin atau ribeye otot longissimus dorsi) yang diukur antara iga ke-12 dan ke-13 dalam inci persegi menggunakan kisi (mis., 8, 9 atau 10 inci). Area ribeye secara langsung terkait dengan jumlah otot di dalam bangkai.",
    animalStatus: "Status hewan di peternakan misalnya: di peternakan, dijual, mati dll"
  },
  manageAnimalGroupings: {
    resetModeTooltip: `
                                                                    Reset mode <br>
                                                                    Dalam mode ini <br>
                                                                    1) Tetapkan/tentukan semua karakteristik kelompok kontemporer (CGS) untuk semua sifat yang menarik. <br>
                                                                    2) Tetapkan semua hewan ke CG yang sesuai. <br>
                                                                    3) Jika penugasan hewan tidak memuaskan", sesuaikan/ubah CGS", dan kemudian tentukan hewan ke CGS yang sesuai baru. <br>
                                                                    4) Ulangi langkah -langkah di atas", jika perlu", sampai Anda memenuhi CGS dan pengelompokan/penugasan hewan yang sesuai. <br>
                                                                    `,
    maintainanceModeHeadingTooltip: `Setelah reset (mode) diselesaikan", Anda akan memasuki mode pemeliharaan di mana EDP dihitung pada reset akan tetap konstan untuk setiap hewan sampai reset berikutnya (yang bisa 2-6 bulan lagi). Selain itu", setiap hewan baru yang ditambahkan atau lahir dari hewan yang sudah ada dalam sistem selama mode pemeliharaan akan menghitung EPD mereka melalui metode lain", metode leluhur", sampai mereka dihitung ulang dalam reset berikutnya.`,
    maintainanceModeTooltip: `Setelah menyelesaikan mode reset", tekan tombol reset yang diselesaikan untuk mengaktifkan sistem untuk menghitung EPD dari semua hewan, menghentikan mode reset, dan memulai mode pemeliharaan.`,
    resetToggleTooltip: `Aktifkan reset sakelar dalam pengaturan model EPD untuk menugaskan hewan ke CGS.`,
  },

  geneticsAndBreeding: {
    geneticsAndBreeding: "Genetika",
    geneticSearchTool: "Alat Pencarian Genetik",
    dataSubmission: "Pengiriman Data",
    animalsWithExpectedProgenyDifferences:
      "Hewan dengan Perbedaan Progeni yang Diharapkan (EPD)",
    searchByAnimalIdName: "Cari berdasarkan Id Hewan, Nama",
    rowsPerPage: "Baris per halaman",
    individualEntry: "Entri Individu",
    bulkEntry: "Entri Massal",
    registerANewAnimalOrSelectAnExistingAnimal:
      "Daftarkan hewan baru atau pilih hewan yang sudah ada.",
    registerNewAnimal: "Daftar Hewan Baru",
    selectExistingAnimal: "Pilih Hewan yang Ada",
    animalID: "ID Hewan",
    animalName: "Nama Hewan",
    tag: "Menandai",
    dateOfBirth: "Tanggal lahir",
    gender: "Jenis kelamin",
    birthDate: "Tanggal lahir",
    birthWeightLb: "Berat Lahir (lb)",
    birthWeightKg: "Berat Lahir (kg)",
    weaningWeightLb: "Berat Penyapihan (lb)",
    weaningWeightKg: "Berat Penyapihan (kg)",
    yearlingWeightLb: "Berat Setahun (lb)",
    yearlingWeightKg: "Berat Setahun (kg)",
    carcassWeightLb: "Berat Karkas (lb)",
    carcassWeightKg: "Berat Karkas (kg)",
    animalSelection: "Seleksi Hewan",
    animalSearchTool: "Alat Pencarian Hewan",
    back: "Kembali",
    searchByEPDs: "Cari berdasarkan EPD",
    searchByIds: "Cari berdasarkan Id",
    selectBreed: "Pilih Breed",
    selectGender: "Pilih jenis kelamin",
    selectRequiredBreedForCattle: "Pilih Breed yang Diperlukan Untuk Ternak",
    resetFilter: "ULANG FILTER",
    birthWeightHeader: "Berat Lahir (BB): ",
    birthWeightDef:
      "Membandingkan perbedaan berat anak sapi saat lahir dan diukur dalam pound atau kg.",
    weaningWeightHeader: "Berat Penyapihan (WW): ",
    weaningWeightDef:
      "WW EPD adalah perkiraan pertumbuhan sebelum penyapihan yang diukur dalam pound atau kg.",
    yearlingWeightHeader: "Berat Setahun (YW): ",
    yearlingWeightDef:
      "YW EPD adalah perkiraan pertumbuhan pasca penyapihan yang diukur dalam pound atau kg.",
    ribEyeAreaHeader: "Area Ribeye (REA): ",
    ribEyeAreaDef:
      "REA mengukur ukuran otot yang memberi kita ribeye dalam inci persegi. EPD REA mencerminkan perbedaan dalam pengukuran area ribeye 365 hari yang disesuaikan berdasarkan pengukuran karkas sapi yang dipanen.",
    marblingHeader: "Marmer (MARB): ",
    marblingDef:
      "EPD MARB adalah dalam satuan persentase lemak intramuskular di dalam ribeye. EPD MARB mencerminkan perbedaan dalam skor marbling 365 hari yang disesuaikan (lemak intramuskular, [IMF]) berdasarkan pengukuran karkas sapi yang dipanen.",
    fatThicknessHeader: "Ketebalan Lemak (FAT): ",
    fatThicknessDef:
      "Inci lemak punggung (dalam seperseratus inci) adalah satuan ukuran untuk FT.",
    carcassWeightHeader: "Berat Karkas (CW): ",
    carcassWeightDef:
      "Bobot karkas adalah sifat yang menguntungkan ketika mempertimbangkan dampak yang dimiliki pound relatif terhadap nilai produk akhir. ",
    yieldGradeHeader: "Nilai Hasil (YG): ",
    yieldGradeDef:
      "Sistem penilaian Tingkat Hasil USDA adalah unit pengukuran untuk YG EPD. ",
    milkHeader: "Susu (MK): ",
    milkDef:
      "MK EPD diukur dalam satuan pon berat sapih pedet karena kemampuan induknya memerah susu.",
    totalMaternalHeader: "Total Ibu (TM): ",
    totalMaternalDef:
      "Pengukuran TM berdampak pada bobot sapih pedet karena produksi susu dan genetik sapi untuk pertumbuhan.",
    calvingEaseDirectHeader: "Calving Ease Direct (CED): ",
    calvingEaseDirectDef:
      "CED EPD terdaftar sebagai persentase pedet tanpa bantuan.",
    calvingEaseMaternalHeader: "Calving Ease Maternal (CEM): ",
    calvingEaseMaternalDef:
      "Mengukur kemampuan anak perempuan banteng untuk melahirkan anak sapi tanpa bantuan saat berusia dua tahun.",
    stayabilityHeader: "Ketahanan (TINGGAL): ",
    stayabilityDef:
      "ST EPD memprediksi kemampuan seekor banteng untuk menjadi bapak sapi yang “tetap tinggal”. ",
    docilityHeader: "Kepatuhan (DOC): ",
    docilityDef: "DOC mengukur temperamen ternak.",
    max: "MAKS",
    min: "MIN",
    accuracy: "KETEPATAN",
    sortBy: "Sortir dengan",
    traits:
      "Ciri-ciri yang ditampilkan dalam warna abu-abu sedang dalam pengembangan, hadir pada Q2, 2023.",
    searchResults: "Hasil Pencarian",
    recordsFound: "catatan ditemukan",
    compareSelected: "BANDINGKAN PILIHAN",
    animalIdentification: "Identifikasi Hewan",
    errorMessage: {
      birthWeight:
        "Nilai maksimum berat lahir tidak boleh kurang dari berat lahir minimum",
      weaningWeight:
        "Nilai maksimum bobot penyapihan tidak boleh kurang dari bobot minimum penyapihan",
      yearlingWeight:
        "Nilai maksimum bobot tahunan tidak boleh kurang dari minimum bobot tahunan",
      carcassWeight:
        "Nilai maksimum berat karkas tidak boleh kurang dari berat minimum lahir",
      fatThickness:
        "Nilai maksimum Ketebalan Lemak tidak boleh kurang dari minimum Berat Penyapihan",
      marbling:
        "Nilai maksimum marmer tidak boleh kurang dari minimum berat tahunan",
      ribeyeArea:
        "Nilai maksimum Area Ribeye tidak boleh kurang dari minimum berat lahir",
      yieldGrade:
        "Nilai maksimum Tingkat Hasil tidak boleh kurang dari minimum Bobot Penyapihan",
      milk:
        "Nilai maksimal susu tidak boleh kurang dari bobot minimal penyapihan",
    },
    reg: "Reg",
    name: "Nama",
    sex: "Seks",
    tattoo: "Tato",
    dob: "Tgl",
    EPD: "EPD",
    rank: "Pangkat",
    searchValue: "Nilai Pencarian",
    typeHere: "Ketik di sini",
    searching: "Mencari...",
    fetchingResult: "Mengambil hasil...Harap tunggu",
    animalsMatchedYourCriteria: "Hewan Sesuai dengan Kriteria Anda",
    manageAnimalsGrouping: "Kelola Pengelompokan Hewan",
    manageAnimalGroupings: "Kelola Pengelompokan Hewan",
    assignAnimalToContemporaryGroups: "Tetapkan Hewan Untuk Grup Kontemporer",
    resetMode: "Atur Ulang Modus",
    enterResetMode: "Masuk ke Mode Reset",
    maintainanceMode: "Modus Pemeliharaan",
    assigningAnimals: "Menugaskan Hewan",
    excludedAnimals: "Hewan yang Dikecualikan",
    ungroupedAnimals: "Hewan yang tidak dikelompokkan",
    assignAnimalsToCGS: "Tetapkan Hewan Ke CGS",
    reset: "Mengatur ulang",
    excludeAnimals: "Kecualikan Hewan",
    resetToMaintainanceMode: "Atur Ulang Selesai - Ubah ke Mode Pemeliharaan",
    contemporaryGroupsSettings: "Pengaturan Grup Kontemporer (CG).",
    selectTrait: "Pilih Sifat",
    selectTraitDescription:"Pilih Sifat mengacu pada proses memilih sifat tertentu",
    traitsType: {
      birthWeight: "Berat lahir",
      weaningWeight: "Berat Penyapihan",
      yearlingWeight: "Berat Setahun",
      carcassWeight: "Berat Karkas",
    },
    addNewGroup: "TAMBAHKAN GRUP BARU",
    contemporaryGroup: "Grup kontemporer",
    contemporaryGroups: "Grup Kontemporer",
    editGroup: "Sunting Grup",
    birthCGCode: "Kode Kelahiran (CG).",
    groupName: "Nama grup",
    birthSex: "Seks Kelahiran",
    conceptionMethod: "Metode Konsepsi",
    weaningCGCode: "Kode Penyapihan (CG).",
    yearlingCGCode: "Kode Yearling(CG).",
    dateWeight: "Berat Tanggal",
    weaningyearlingCGcode: "Kode Penyapihan/Yearling(CG).",
    carcassCGCode: "Kode Karkas (CG).",
    breedOfDom: "Jenis Dom",
    addNewContemporaryGroup: "Tambahkan Grup Kontemporer Baru",
    createNewGroup: "Buat Grup Baru",
    selectFromDifferentTraits: "Pilih dari sifat yang berbeda",
    contemporaryGroupName: "Nama Grup Kontemporer",
    enterNameHere: "Masukkan nama di sini",
    groupNameIsRequired: "Nama Grup wajib diisi",
    birthYearRange: "Kisaran Tahun Lahir",
    theYearAnimalWasBorn: "Tahun hewan lahir",
    birthYearIsRequired: "Tahun Kelahiran diperlukan",
    genderOfNewBornAnimal: "Jenis kelamin hewan yang baru lahir",
    selectSex: "Pilih Jenis Kelamin",
    theweightOfAnimalAtBirth: "Berat hewan saat lahir",
    maximumKg: "Maksimum (Kg)",
    minimumKg: "Minimum (Kg)",
    aSeasonisAPeriodOfYear:
      "Musim adalah periode tahun yang dibedakan oleh kondisi iklim khusus.",
    seasonofBirthIsRequired: "Musim Kelahiran diperlukan",
    majorGenericContributionOfAnimal: "% Besar Kontribusi Generik Hewan",
    primaryBreedCompostionIsRequired: "Komposisi Breed Primer diperlukan",
    secondaryBreedCompostionIsRequired: "Komposisi Breed Sekunder diperlukan",
    howTheAnimalWasConceived:
      "Bagaimana hewan itu dikandung (perkawinan alami/inseminasi/transfer embrio)",
    conceptionMethodIsRequired: "Metode Konsepsi diperlukan",
    epdModelSettings: "Pengaturan Model EPD",
    forResetMode: "Untuk Mode Reset",
    progenyWeightingFactor: "Faktor Pembobot Keturunan",
    weightGivenToTheProgenyFactor:
      "Bobot yang diberikan pada faktor progeni relatif terhadap faktor CG untuk perhitungan EPD dalam mode Reset. ",
    enterNumber: "Masukkan Nomor",
    enterBreed: "Masukkan Breed",
    valueShouldBeBetween0and1: "Nilai harus antara 0 dan 1",
    resetDuration: "Atur Ulang Durasi",
    timeIntervalBetweenLastAndFirstResetMode:
      "Interval waktu antara mode reset terakhir dan mode reset baru, pada akhirnya mode reset baru diaktifkan dan CG dan EPD baru dihitung.",
    enterNumberOfDays: "Masukkan Jumlah Hari",
    valueCannotBeNegative: "Nilai tidak boleh negatif!",
    criticalProgenyPopulation: "Populasi Keturunan Kritis",
    minimumNumberOfProgenyRecords:
      "Jumlah minimum catatan progeni individu hewan dalam sistem yang diperlukan untuk mencapai Akurasi Progeni (APD1) di atas 50% (untuk Akurasi Pedigree)",
    criticalAncestorPopulation: "Populasi Leluhur Kritis",
    minimumNumberOfAncestorsRecords:
      "Jumlah minimum catatan leluhur hewan individu dalam sistem yang diperlukan untuk mencapai Akurasi Leluhur (APD4) di atas 50% (untuk Akurasi Silsilah)",
    forBirthWeightCG: "Untuk Berat Lahir CG",
    criticalPopulationInAnimalsContemporaryGroup:
      "Populasi Kritis Dalam Kelompok Hewan Kontemporer",
    minimumAverageNumberOfAnimalsPerBirthWeight:
      "Jumlah rata-rata minimum hewan per kelahiran berat CG diperlukan untuk mencapai Average CG Accuracy (ACG3) di atas 50%",
    criticalAveragePopulationPerContemporaryGroup:
      "Populasi Rata-Rata Kritis Per Kelompok Kontemporer",
    minimumNumberOfAnimalsInBirthWeight:
      "Jumlah minimum hewan dalam CG berat lahir hewan yang diperlukan untuk mencapai CG Accuracy (ACG2) di atas 50%",
    forWeaningWeightCG: "Untuk Berat Penyapihan CG",
    minimumAverageNumberOfAnimalsPerWeaningWeight:
      "Jumlah rata-rata minimum hewan per CG berat sapih yang diperlukan untuk mencapai Akurasi CG Rata-Rata (ACG3) di atas 50%",
    minimumNumberOfAnimalsInWeaningWeight:
      "Jumlah minimum hewan dalam CG berat sapih hewan yang diperlukan untuk mencapai CG Accuracy (ACG2) di atas 50%",
    forYearlingWeightCG: "Untuk Berat Setahun CG",
    minimumAverageNumberOfAnimalsPerYearling:
      "Jumlah rata-rata minimum hewan per Tahun CG yang diperlukan untuk mencapai Akurasi CG Rata-Rata (ACG3) di atas 50%",
    minimumNumberOfAnimalsInYearlingWeight:
      "Jumlah minimum hewan dalam CG berat tahunan hewan yang diperlukan untuk mencapai Akurasi CG (ACG2) di atas 50%",
    forCarcassCG: "Untuk Karkas CG",
    minimumAverageNumberOfAnimalsPerCarcassWeight:
      "Jumlah rata-rata minimum hewan per Karkas berat CG yang diperlukan untuk mencapai Average CG Accuracy (ACG3) di atas 50%",
    minimumNumberOFAnimalInCarcassWeight:
      "Jumlah minimum hewan dalam CG Berat Karkas hewan yang diperlukan untuk mencapai CG Accuracy (ACG2) di atas 50%",
    epdRequiredFieldSettings: "Pengaturan Bidang Wajib EPD",
    pleaseSelectRequiredFieldsForCompleteEPD:
      "Silakan pilih bidang yang diperlukan untuk perhitungan EPD lengkap",
    byDefault: "Secara Default",
    pleaseNoteThatUsersNotAbleToObtainFullEPD:
      "Catatan: Perlu diketahui bahwa pengguna tidak akan dapat memperoleh perhitungan EPD lengkap jika mereka tidak memberikan bidang data yang Anda tandai sebagai wajib.",
    pleaseNoteThatRequiredFieldParametersCannotBeChanged:
      "Catatan: Perlu diketahui bahwa parameter kolom wajib tidak dapat diubah karena sudah ada grup kontemporer terhadap parameter sebelumnya.",
    noResultFound: "TIDAK DITEMUKAN HASIL",
    next: "Berikutnya",
    cancel: "Membatalkan",
    selectAnimal: "Pilih Hewan",
    searchBy: "Cari Berdasarkan",
    breed: "Keturunan",
    regDate: "Reg. ",
    status: "Status",
    animalDetails: "Detail Hewan",
    add: "Menambahkan",
    update: "Memperbarui",
    dataForEPDs: " Data untuk EPD",
    basicInformation: "Informasi dasar",
    birthWeightInformation: "Informasi Berat Lahir",
    weaningWeightInformation: "Informasi Berat Penyapihan",
    yearlingWeightInformation: "Informasi Berat Setahun",
    carcassWeightInformation: "Informasi Berat Karkas",
    delete: "Menghapus",
    deleteEpdData: "Hapus Data EPD",
    areYouSureYouWantToDeleteEpdData: "Anda yakin ingin menghapus data EPD.",
    internationalID: "tanda pengenal internasional",
    enterID: "Masukkan ID",
    animalRegistration: "Registrasi Hewan",
    location: "Lokasi",
    additionalIDMethod: "Metode ID tambahan",
    damID: "ID Bendungan",
    sireID: "Tuan ID",
    breederHerdCode: "Kode Peternakan Peternak",
    birthYear: "tahun lahir",
    primaryBreed: "Trah Primer",
    breedComposition: "Komposisi Trah",
    secondaryBreed: "Trah Sekunder",
    seasonofBirth: "Musim Kelahiran",
    birthManagementCode: "Kode Manajemen Kelahiran",
    damAge: "Kerusakan",
    years: "Bertahun-tahun",
    birthContemporaryCode: "Kelahiran Kode Kontemporer",
    accuracyWeight: "Berat Akurasi",
    noteMinimumRequiredFieldForBirthWeight:
      "Catatan: Bidang minimum wajib untuk EPD berat lahir, tahun lahir, jenis kelamin, metode konsepsi, berat lahir.",
    note: "Catatan",
    minimumRequiredFieldForBirthWeight:
      "Bidang minimum yang diperlukan untuk EPD Berat Lahir",
    birthYearGenderConceptionMethodBirthWeight:
      "Tahun Lahir , Jenis Kelamin , Metode Konsepsi , Berat Badan Lahir",
    weaningWeight: "Berat Penyapihan",
    weaningDate: "Tanggal penyapihan",
    weaningContemporaryGroupCode: "Menyapih Kode Grup Kontemporer",
    creep: "Orang aneh",
    managementPastureCode: "Kode Pengelolaan/Pasture",
    weaningSex: "Menyapih Seks",
    minimumRequiredFieldForWeaningWeight:
      "Bidang minimum yang diperlukan untuk EPD Berat Penyapihan",
    weaningWeightManagementPastureCodeWeaningSexDateWeighed:
      "Berat Sapih , Tatalaksana/Kode Padang Rumput , Jenis Kelamin Menyapih , Tanggal Ditimbang",
    yearlingWeight: "Berat Setahun",
    yearlingHeight: "Tinggi Setahun",
    yearlingDate: "Tanggal Setahun",
    yearlingContemporaryGroupCode: "Kode Grup Kontemporer Setahun",
    managementFeedingCode: "Kode Manajemen / Pemberian Makan",
    yearlingSex: "Seks Setahun",
    youWillNeedToFillOutFor:
      "Anda harus mengisi semua bidang untuk mengambil data EPD",
    pleaseSelectHavestDateFirstToEnterInfo:
      "Silakan pilih 'Tanggal Panen' terlebih dahulu untuk memasukkan info untuk Rib Eye Area, Fat Thickness dan Marbling",
    harvestDate: "Tanggal Panen",
    dateOnFeed: "Tanggal Umpan",
    daysOnFeed: "Hari-hari Memberi Makan",
    gradingDate: "Tanggal Penilaian",
    carcassSex: "Seks Bangkai",
    carcassWeight: "Berat Karkas",
    carcassContemporary: "Karkas Kontemporer",
    damBreed: "Bibit Bendungan",
    ribEyeArea: "Area Rib Eye",
    ribEyeAreaContemporary: "Rib Eye Area Kontemporer",
    fatThickness: "Ketebalan Lemak",
    fatThicknessContemporary: "Tebal Lemak Kontemporer",
    marbling: "Marmer",
    marblingContemporary: "Marmer Kontemporer",
    yieldGradeContemporary: "Tingkat Hasil Kontemporer",
    animalsNotListedInContemporaryGroupsMsg:
      "Hewan belum ditambahkan ke grup kontemporer mana pun karena informasi yang hilang. ",
    listOfUngroupedAnimals: "Daftar Hewan yang Tidak Dikelompokkan",
    submittingData: "Mengirimkan Data",
    resendToUser: "Kirim Ulang Ke Pengguna",
    submittingAnimalsInGroupMsg: "Mengirimkan hewan Anda ke dalam kelompok. ",
    pressingResetBtnMsg:
      'Menekan tombol "Atur Ulang" akan memulai proses untuk menugaskan kembali hewan ke grup kontemporer mereka.',
    doYouWantToProceed: "Apakah Anda ingin melanjutkan?",
    systemMaintainanceModeMsg:
      'Menekan tombol "Ubah ke Mode Pemeliharaan" akan memulai proses dan sistem Anda akan masuk ke "MODE PEMELIHARAAN" di mana EDP yang dihitung pada RESET akan dijaga konstan untuk setiap hewan hingga RESET berikutnya (yang bisa jadi 1-6 bulan). ',
    errorFetchingContemporaryGrpMsg:
      "Terjadi error saat mengambil data grup kontemporer",
    deleteSuccess: "Hapus Sukses",
    deleteSuccessMsg: "Grup kontemporer berhasil dihapus.",
    deleteFailed: "Hapus Gagal",
    deleteFailedMsg: "Kesalahan saat menghapus data grup kontemporer",
    deleteContemporaryGrpMsg:
      "Anda yakin ingin menghapus grup kontemporer ini?",
    addBirthWeightData: "Tambahkan Data Berat Lahir",
    addWeaningWeightData: "Tambahkan Data Berat Penyapihan",
    birthWeightContemporaryGroupCode: "Kode Grup Berat Lahir Kontemporer",
    dateWeighted: "Tanggal Tertimbang",
    addYearlingWeightData: "Tambahkan Data Berat Setahun",
    addCarcassWeightData: "Menambahkan Data Berat Karkas",
    weaningOrYearlingContemporaryGroupCode:
      "Kode Grup Kontemporer Bobot Penyapihan atau Umur Setahun",
    deleteContemporaryGroupMsg: "Yakin ingin menghapus grup kontemporer?",
    updateSuccessMsg: "Grup kontemporer berhasil diperbarui.",
    errorMsg: "Ada yang salah. ",
    fetchErrorMsg:
      "Terjadi error saat mengambil bidang wajib untuk sifat yang dipilih.",
    forMaintainanceMode: "Untuk Mode Pemeliharaan",
    ancestorsWeightFactor: "Faktor Berat Leluhur",
    weightGivenToTheAncestorFactor:
      "Bobot diberikan pada faktor ancestor relatif terhadap faktor CG untuk perhitungan EPD pada mode Maintenance. ",
    addEPDModelSettingsData: "Tambahkan Data Pengaturan Model EPD",
    minimumNumberOfAnimalsInContemporaryGroups:
      "Jumlah Minimum Hewan dalam Kelompok Kontemporer",
    enterNumberOfAnimals: "Masukkan Jumlah Hewan",
    areYouSureYouWantToChangeEPDCalculation:
      "Apakah Anda yakin ingin mengubah bidang perhitungan EPD yang diperlukan?",
    weightOfAnimalAtBirth: "Berat Hewan Saat Lahir",
    seasonIsAPeriodOfYear:
      "Musim adalah periode tahun yang dibedakan oleh kondisi iklim khusus.",
    codeOfBirthWeightContemporaryGroup: "Kode Kelompok Kontemporer Berat Lahir",
    weaningWeightOfCalf: "Berat Sapih Pedet",
    dateAnimalWasWeaned: "Tanggal hewan disapih",
    genderOfWeaningAnimal: "Jenis Kelamin Hewan Menyapih",
    yearlingWeightOfCalf: "Bobot Anak Sapi Setahun",
    dateAnimalWasWeighted: "Tanggal hewan ditimbang",
    yearledAnimalSex: "Jenis kelamin hewan yang berumur setahun",
    dateOfAnimalKilledForMeat: "Tanggal hewan dibunuh untuk diambil dagingnya",
    addSuccessMsg: "Grup kontemporer berhasil ditambahkan",
    traitH: "Sifat untuk perhitungan EPD.",
    searchByValue: "Masukkan No Pendaftaran/Tato/Nama/Tag"
  },
};
